
export default [
    {
        "id": 1,
        "shikenId": 1,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「FP」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も不適切なものはどれか。[2023.09]",
        "choice1": "金融商品取引業の登録を受けていないFPのAさんは、顧客と資産運用に関する投資顧問契約を締結したうえで、値上がりが期待できる株式の個別銘柄の購入を勧めた。",
        "choice2": "弁護士の登録を受けていないFPのBさんは、財産管理の相談に来た顧客の求めに応じ、有償で、当該顧客を委任者とする任意後見契約の受任者となった。",
        "choice3": "税理士の登録を受けていないFPのCさんは、顧客から配偶者控除と配偶者特別控除の適用要件を聞かれ、所得税法の条文等を示しつつ、それぞれの適用要件の違いを説明した。",
        "choice4": "生命保険募集人の登録を受けていないFPのDさんは、顧客からライフプランの相談を受け、老後資金を準備するための生命保険の一般的な活用方法を説明した。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "FPと関連法規",
        "important": ""
    },
    {
        "id": 2,
        "shikenId": 1,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナーがライフプランニングに当たって作成するキャッシュフロー表の一般的な作成方法に関する次の記述のうち、最も適切なものはどれか。[2023.01]",
        "choice1": "キャッシュフロー表の作成において、可処分所得は、年間の収入金額から直接税、社会保険料および住居費の金額を控除した金額を計上する。",
        "choice2": "キャッシュフロー表の作成において、住宅ローンの返済方法を元金均等返済方式とした場合、その返済額は、毎年同額を計上する。",
        "choice3": "キャッシュフロー表の作成において、基本生活費や教育費等の支出項目に計上した金額は、家族構成が変わらない限り、見直す必要はない。",
        "choice4": "キャッシュフロー表の作成において、各年次の貯蓄残高は、「前年末の貯蓄残高×(1＋運用利率)＋当年の年間収支」の算式で計算した金額を計上する。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表の作成方法",
        "important": ""
    },
    {
        "id": 3,
        "shikenId": 1,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も適切なものはどれか。[2022.05]",
        "choice1": "労災保険の保険料を計算する際に用いる労災保険率は、常時使用する従業員数に応じて定められている。",
        "choice2": "労働者が業務上の負傷または疾病による療養のために労働することができず、賃金の支給を受けられない場合、賃金の支給を受けられない日の1日目から休業補償給付が支給される。",
        "choice3": "労働者が業務上の負傷または疾病により、労災指定病院で療養補償給付として受ける療養の給付については、労働者の一部負担金はない。",
        "choice4": "労働者が業務上の負傷または疾病が治癒したときに一定の障害が残り、その障害の程度が所定の障害等級に該当するときは、障害補償年金または障害補償一時金のいずれかを選択して受給することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "労災保険",
        "important": ""
    },
    {
        "id": 4,
        "shikenId": 1,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "雇用保険に関する次の記述のうち、最も不適切なものはどれか。[2024.05]",
        "choice1": "雇用保険に係る保険料のうち、失業等給付および育児休業給付に係る保険料は、事業主と労働者が折半して負担する。",
        "choice2": "雇用保険の適用事業所に雇用される労働者であって、所定の要件を満たす者は、日本国籍の有無にかかわらず、雇用保険の被保険者となる。",
        "choice3": "特定受給資格者等を除く一般の受給資格者に支給される基本手当の所定給付日数は、算定基礎期間が10年以上20年未満の場合、150日である。",
        "choice4": "一般被保険者が失業した場合、基本手当の支給を受けるためには、原則として、離職の日以前2年間に被保険者期間が通算して12ヵ月以上あること等の要件を満たす必要がある。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険",
        "important": ""
    },
    {
        "id": 5,
        "shikenId": 1,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "国民年金の保険料に関する次の記述のうち、最も不適切なものはどれか。[2022.09]",
        "choice1": "国民年金の付加保険料は、将来の一定期間の保険料を前納することができ、前納する期間に応じて所定の額が控除される。",
        "choice2": "第1号被保険者で障害基礎年金または障害等級1級もしくは2級の障害厚生年金を受給している者は、原則として、所定の届出により、保険料の納付が免除される。",
        "choice3": "第1号被保険者が出産する場合、所定の届出により、出産予定月の前月から4ヵ月間（多胎妊娠の場合は出産予定月の3ヵ月前から6ヵ月間）、保険料の納付が免除される。",
        "choice4": "保険料免除期間に係る保険料を追納する場合、追納保険料は、追納する時期にかかわらず、免除された時点における保険料の額となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金の保険料",
        "important": ""
    },
    {
        "id": 6,
        "shikenId": 1,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "公的年金等に係る税金に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。[2022.09]",
        "choice1": "老齢基礎年金および老齢厚生年金は、その年中に受け取る当該年金の収入金額から公的年金等控除額を控除した金額が一時所得として所得税の課税対象となる。",
        "choice2": "障害基礎年金および障害厚生年金は、所得税の非課税所得となる。",
        "choice3": "老齢基礎年金および老齢厚生年金の受給者が死亡した場合において、その者に支給されるべき年金給付のうち、まだ支給されていなかったもの（未支給年金）は、当該年金を受け取った遺族の一時所得として所得税の課税対象となる。",
        "choice4": "国民年金の保険料および国民年金基金の掛金は、いずれも社会保険料控除として所得税の所得控除の対象となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の税金",
        "important": ""
    },
    {
        "id": 7,
        "shikenId": 1,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "公的年金制度の障害給付および遺族給付に関する次の記述のうち、最も不適切なものはどれか。[2024.01]",
        "choice1": "障害等級1級または2級に該当する程度の障害の状態にある障害厚生年金の受給権者が、所定の要件を満たす配偶者を有する場合、その受給権者に支給される障害厚生年金には加給年金額が加算される。",
        "choice2": "障害厚生年金の額を計算する際に、その計算の基礎となる被保険者期間の月数が300月に満たない場合、300月として計算する。",
        "choice3": "遺族基礎年金を受給することができる遺族は、国民年金の被保険者等の死亡の当時、その者によって生計を維持され、かつ、所定の要件を満たす「子のある配偶者」または「子」である。",
        "choice4": "遺族厚生年金の受給権者が、65歳到達日に老齢厚生年金の受給権を取得した場合、65歳以降、その者の選択によりいずれか一方の年金が支給され、他方の年金は支給停止となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "障害給付と遺族給付",
        "important": ""
    },
    {
        "id": 8,
        "shikenId": 1,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も適切なものはどれか。[2024.09]",
        "choice1": "国民年金基金の掛金月額は、選択した給付の型および加入口数に応じて決まり、加入時の年齢や性別による差異はない。",
        "choice2": "小規模企業共済の掛金は、確定拠出年金の個人型年金の掛金との合計で、月額68,000円が限度とされている。",
        "choice3": "小規模企業共済では、共済契約の解約時における掛金納付月数が12ヵ月未満である場合、解約事由にかかわらず、解約手当金は支給されない。",
        "choice4": "中小企業退職金共済の掛金は、事業主と従業員の合意に基づき、事業主と従業員が折半して負担することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金、小規模企業共済、中退共",
        "important": ""
    },
    {
        "id": 9,
        "shikenId": 1,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も適切なものはどれか。[2022.05]",
        "choice1": "損益分岐点比率は、実際の売上高に対する損益分岐点売上高の割合を示したものであり、一般に、この数値が低い方が企業の収益性が高いと判断される。",
        "choice2": "自己資本比率は、総資本に対する自己資本の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice3": "固定長期適合率は、自己資本に対する固定資産の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice4": "ROEは、自己資本に対する当期純利益の割合を示したものであり、一般に、この数値が低い方が経営の効率性が高いと判断される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "決算書に基づく経営分析指標",
        "important": ""
    },
    {
        "id": 10,
        "shikenId": 1,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンの一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。[2025.05]",
        "choice1": "住宅ローンの返済方法において、元利均等返済と元金均等返済を比較した場合、借入額や返済期間などの他の条件が同一であれば、総返済額は元利均等返済のほうが多くなる。",
        "choice2": "住宅ローンの一部繰上げ返済において、返済額軽減型と返済期間短縮型を比較した場合、繰上げ返済額や金利などの他の条件が同一であれば、利息の軽減効果は返済額軽減型のほうが大きくなる。",
        "choice3": "住宅ローンの一部繰上げ返済をする場合、取扱金融機関によって最低返済額や必要となる手数料が異なることがある。",
        "choice4": "住宅ローンの借換えに際して、現在借入れをしている金融機関の抵当権を抹消し、借換先の金融機関の抵当権を設定する場合、登録免許税等の諸費用が必要となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの一般的な特徴",
        "important": ""
    },
    {
        "id": 11,
        "shikenId": 1,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険の保険料等の一般的な仕組みに関する次の記述のうち、最も不適切なものはどれか。[2023.05]",
        "choice1": "収支相等の原則は、保険会社が受け取る保険料等の総額が、保険会社が支払う保険金等の総額と等しくなるように保険料を算定する原則をいう。",
        "choice2": "保険料のうち、将来の保険金等の支払財源となる純保険料は、予定死亡率に基づいて計算され、保険会社が保険契約を維持・管理していくために必要な経費等の財源となる付加保険料は、予定利率および予定事業費率に基づいて計算される。",
        "choice3": "終身保険について、保険料の算定に用いられる予定利率が引き上げられた場合、新規契約の保険料は安くなる。",
        "choice4": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも少なかった場合、費差益が生じる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の保険料等の一般的な仕組み",
        "important": ""
    },
    {
        "id": 12,
        "shikenId": 1,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。[2024.09]",
        "choice1": "養老保険では、被保険者が病気で高度障害状態となり、高度障害保険金が支払われた場合、保険契約は消滅する。",
        "choice2": "変額保険（終身型）では、契約時に定めた保険金額（基本保険金額）は保証されておらず、運用実績によっては、死亡保険金額が基本保険金額を下回る。",
        "choice3": "外貨建て終身保険では、円換算支払特約を付加することで、当該保険契約の締結時から保険金を受け取るまでの為替リスクを回避することができる。",
        "choice4": "収入保障保険の死亡保険金を一時金で受け取る場合の受取額は、年金形式で受け取る場合の受取総額よりも多くなる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 13,
        "shikenId": 1,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "総合福祉団体定期保険および団体定期保険（Bグループ保険）の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。[2024.05]",
        "choice1": "総合福祉団体定期保険は、企業（団体）を契約者、従業員等を被保険者とする1年更新の定期保険であり、その契約の締結に際しては、被保険者になることについての加入予定者の同意が必要である。",
        "choice2": "総合福祉団体定期保険のヒューマン・ヴァリュー特約は、被保険者の死亡等による企業（団体）の経済的損失に備えるものであり、その特約死亡保険金等の受取人は企業（団体）となる。",
        "choice3": "団体定期保険（Bグループ保険）は、従業員等が任意に加入する1年更新の定期保険であり、原則として、従業員等が保険料を負担する。",
        "choice4": "団体定期保険（Bグループ保険）の加入に際しては、保険約款に基づく告知および医師の診査が必要である。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "総合福祉団体定期保険および団体定期保険（Bグループ保険）",
        "important": ""
    },
    {
        "id": 14,
        "shikenId": 1,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における生命保険料控除に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、生命保険契約は2012年1月1日以後に締結されたものとし、ほかに必要な要件等はすべて満たしているものとする。[2025.05]",
        "choice1": "勤労者財産形成貯蓄積立保険（一般財形）の保険料は、一般の生命保険料控除の対象となる。",
        "choice2": "特定（三大）疾病保障定期保険の保険料は、一般の生命保険料控除の対象となる。",
        "choice3": "一般の生命保険料控除、個人年金保険料控除および介護医療保険料控除の控除限度額は、各5万円である。",
        "choice4": "終身保険の月払保険料について、保険料の支払がなかったため自動振替貸付により保険料の払込みに充当された金額は、その年分の生命保険料控除の対象とならない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "所得税における生命保険料控除",
        "important": ""
    },
    {
        "id": 15,
        "shikenId": 1,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする生命保険に係る保険料等の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2023年10月に締結したものとする。[2024.01]",
        "choice1": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
        "choice2": "被保険者が役員・従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice3": "被保険者が役員・従業員全員、給付金受取人が法人である医療保険について、法人が受け取った入院給付金および手術給付金は、その全額を益金の額に算入する。",
        "choice4": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が80％である定期保険（保険期間30年）の支払保険料は、保険期間の前半4割相当期間においては、その60％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の生命保険の経理処理",
        "important": ""
    },
    {
        "id": 16,
        "shikenId": 1,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。[2023.01]",
        "choice1": "被保険自動車を運転中に飛び石により窓ガラスにひびが入った場合、一般車両保険の補償の対象となる。",
        "choice2": "被保険自動車を運転中に、通行人が連れていたペットに誤って衝突して死亡させ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice3": "被保険自動車を運転中に衝突事故を起こして被保険者がケガをした場合、被保険者の過失割合にかかわらず、人身傷害（補償）保険の補償の対象となる。",
        "choice4": "被保険自動車を運転中に衝突事故を起こして被保険者の配偶者がケガをした場合、対人賠償保険の補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 17,
        "shikenId": 1,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "地震保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。[2024.05]",
        "choice1": "地震保険は、火災保険の契約時だけでなく、火災保険の保険期間中に付帯することもできる。",
        "choice2": "地震保険の保険料は、保険の対象となる居住用建物の構造と所在地によって異なる。",
        "choice3": "地震保険には、「建築年割引」「免震建築物割引」「耐震等級割引」「耐震診断割引」の保険料割引制度があり、これらは重複して適用を受けることができる。",
        "choice4": "地震保険における損害の程度の区分は、「全損」「大半損」「小半損」「一部損」である。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 18,
        "shikenId": 1,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする損害保険契約の経理処理に関する次の記述のうち、最も不適切なものはどれか。[2022.05]",
        "choice1": "火災により倉庫を焼失するリスクに備えて、保険期間5年の火災保険に加入し、5年分の保険料を一括で支払った場合、その事業年度に、支払った保険料の全額を損金の額に算入することができる。",
        "choice2": "業務中の事故によりケガを負うリスクに備えて、すべての役員・従業員を被保険者および保険金受取人とする普通傷害保険に加入した場合、その支払った保険料の全額を損金の額に算入することができる。",
        "choice3": "法人が所有する業務用自動車が交通事故で損壊し、法人が受け取った自動車保険の車両保険の保険金で修理をした場合、当該保険金を益金の額に算入し、当該修理費を損金の額に算入することができる。",
        "choice4": "積立傷害保険が満期を迎え、法人が満期返戻金と契約者配当金を受け取った場合、その全額を益金の額に算入し、資産に計上していた積立保険料の累計額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の損害保険契約の経理処理",
        "important": ""
    },
    {
        "id": 19,
        "shikenId": 1,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。[2023.09]",
        "choice1": "生命保険会社が取り扱う介護保険は、公的介護保険の加入年齢である40歳から加入可能となり、保険期間は65歳までとされる。",
        "choice2": "医療保険では、人間ドック等の治療を目的としない入院をし、異常が発見されなかった場合、入院給付金は支払われない。",
        "choice3": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、療養を受けた時点において厚生労働大臣によって定められたものである。",
        "choice4": "がん保険では、被保険者ががんで入院したことにより受け取る入院給付金について、1回の入院での支払日数に制限はない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "第三分野の保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 20,
        "shikenId": 1,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "損害保険を活用した事業活動のリスク管理に関する次の記述のうち、最も不適切なものはどれか。[2025.05]",
        "choice1": "レストランを営む事業者が、提供した料理が原因で食中毒を発生させ、法律上の損害賠償責任を負担する場合に備えて、生産物賠償責任保険（PL保険）を契約した。",
        "choice2": "貸しビル業を営む事業者が、火災により所有するビル内に設置した機械に損害が生じる場合に備えて、機械保険を契約した。",
        "choice3": "建設業を営む事業者が、請け負った建築工事中に誤って工具を落として第三者にケガをさせ、法律上の損害賠償責任を負担する場合に備えて、請負業者賠償責任保険を契約した。",
        "choice4": "製造業を営む事業者が、業務中の事故により従業員やパート従業員がケガをする場合に備えて、労働者災害補償保険（政府労災保険）の上乗せ補償を目的として労働災害総合保険を契約した。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険を活用した事業活動のリスク管理",
        "important": ""
    },
    {
        "id": 21,
        "shikenId": 1,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "全国企業短期経済観測調査（日銀短観）に関する次の記述のうち、最も適切なものはどれか。[2022.05]",
        "choice1": "日銀短観は、統計法に基づいて行われる調査であり、全国の企業動向を的確に把握し、政府の財政政策の適切な運営に資することを目的としている。",
        "choice2": "日銀短観の調査は年4回実施され、その結果は、3月、6月、9月、12月に公表される。",
        "choice3": "日銀短観の調査対象企業は、全国の資本金1,000万円以上の民間企業（金融機関等を除く）の中から抽出され、各種計数が業種別および企業規模別に公表される。",
        "choice4": "日銀短観で公表される「業況判断DI」は、回答時点の業況とその3カ月後の業況予測について、「良い」と回答した企業の社数構成比から「悪い」と回答した企業の社数構成比を差し引いて算出される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "全国企業短期経済観測調査（日銀短観）",
        "important": ""
    },
    {
        "id": 22,
        "shikenId": 1,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預貯金の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。[2024.01]",
        "choice1": "決済用預金は、「無利息」「要求払い」「決済サービスを提供できること」という3つの条件を満たした預金である。",
        "choice2": "当座預金は、株式の配当金の自動受取口座として利用することができる。",
        "choice3": "スーパー定期預金は、預入期間が3年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは法人に限られる。",
        "choice4": "大口定期預金は、最低預入金額が1,000万円に設定された固定金利型の定期預金である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預貯金の一般的な商品性",
        "important": ""
    },
    {
        "id": 23,
        "shikenId": 1,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "株式投資信託の一般的な運用手法等に関する次の記述のうち、最も適切なものはどれか。[2024.05]",
        "choice1": "マクロ的な環境要因等を基に国別組入比率や業種別組入比率などを決定し、その比率に応じて、個別銘柄を組み入れてポートフォリオを構築する手法を、ボトムアップ・アプローチという。",
        "choice2": "割高な銘柄の買建てと割安な銘柄の売建てをそれぞれ同程度の金額で行い、市場全体の変動に左右されない収益の確保を目指す手法を、マーケット・ニュートラル運用という。",
        "choice3": "企業の将来の売上高や利益の成長性が市場平均よりも高いと見込まれる銘柄を組み入れて運用するグロース運用は、PERやPBRが低い銘柄中心のポートフォリオとなる傾向がある。",
        "choice4": "「ブル型」「ベア型」と呼ばれる特殊型の投資信託のうち、「ベア型」は、ベンチマークが下落すると基準価額が上昇するように設計されている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の分類方法",
        "important": ""
    },
    {
        "id": 24,
        "shikenId": 1,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ETF）の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。[2022.05]",
        "choice1": "ETFは、非上場の投資信託と異なり、運用管理費用（信託報酬）は発生しない。",
        "choice2": "ETFは、支払われる分配金が自動で再投資されるため、投資の複利効果を得ることができる。",
        "choice3": "ETFには、NISAの「つみたて投資枠」の対象となっているものがある。",
        "choice4": "ETFには、株価指数に連動するものはあるが、REIT指数や商品指数に連動するものはない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託(ETF)",
        "important": ""
    },
    {
        "id": 25,
        "shikenId": 1,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "債券投資のリスクに関する次の記述のうち、最も不適切なものはどれか。[2024.05]",
        "choice1": "債券の発行体の所在する国や地域における政治・経済状況の変化等により、債券価格が大きく変動したり、債券の元本や利子の支払不能等が生じたりするリスクを、一般に、カントリーリスクという。",
        "choice2": "債券の価格変動リスクは、表面利率などの他の条件が同一であれば、一般に、残存期間が長いほど高くなる。",
        "choice3": "債券の信用格付けにおいて、B（シングルビー）格相当以上の格付けが付された債券は、一般に、投資適格債と呼ばれ、信用リスクが低い債券とされる。",
        "choice4": "外貨建て債券の為替変動リスクを回避または軽減する方法の一つとして、当該債券の購入時に、その償還日にあわせて為替予約を行う為替ヘッジが考えられる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券投資のリスク",
        "important": ""
    },
    {
        "id": 26,
        "shikenId": 1,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "下記＜X社のデータ＞に基づき算出される投資指標に関する次の記述のうち、最も不適切なものはどれか。[2023.05]<br><img src='/img/26_0416.jpg'>",
        "choice1": "ROEは、3.75％である。",
        "choice2": "PERは、18倍である。",
        "choice3": "PBRは、0.54倍である。",
        "choice4": "配当性向は、40％である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標",
        "important": ""
    },
    {
        "id": 27,
        "shikenId": 1,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も適切なものはどれか。[2023.09]",
        "choice1": "クーポンスワップは、異なる通貨間で将来の金利および元本を交換する通貨スワップである。",
        "choice2": "先物取引を利用したヘッジ取引には、将来の価格上昇リスク等を回避または軽減する売りヘッジと、将来の価格下落リスク等を回避または軽減する買いヘッジがある。",
        "choice3": "オプション取引において、コール・オプションの買い手は「権利行使価格で買う権利」を放棄することができるが、プット・オプションの買い手は「権利行使価格で売る権利」を放棄することができない。",
        "choice4": "オプション取引において、コール・オプションの売り手の最大利益とプット・オプションの売り手の最大利益は、いずれもプレミアム（オプション料）の額となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融派生商品",
        "important": ""
    },
    {
        "id": 28,
        "shikenId": 1,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "ポートフォリオ理論に関する次の記述のうち、最も不適切なものはどれか。[2022.05]",
        "choice1": "ポートフォリオのリスクとは、一般に、組成されたポートフォリオの損失額の大きさを示すのではなく、そのポートフォリオの期待収益率と実際の収益率の乖離の度合いをいう。",
        "choice2": "異なる2資産からなるポートフォリオにおいて、2資産間の相関係数がゼロである場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減効果）は生じない。",
        "choice3": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を組入比率で加重平均した値となる。",
        "choice4": "ポートフォリオのリスクは、組み入れた各資産のリスクを組入比率で加重平均した値以下となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "ポートフォリオ理論",
        "important": ""
    },
    {
        "id": 29,
        "shikenId": 1,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "NISA（少額投資非課税制度）に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、NISAにより投資収益が非課税となる口座をNISA口座という。[2025.05]",
        "choice1": "NISAのつみたて投資枠と成長投資枠の双方を、同一年中において、併せて新規投資に利用することはできない。",
        "choice2": "NISA口座は、その年の1月1日時点において20歳未満の者は、開設することができない。",
        "choice3": "NISAのつみたて投資枠を利用して購入した株式投資信託の非課税保有期間は、最長で20年間とされている。",
        "choice4": "NISAのつみたて投資枠を利用して1年間のうちに株式投資信託を購入することができる限度額（年間投資枠）は、120万円である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA",
        "important": ""
    },
    {
        "id": 30,
        "shikenId": 1,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "わが国における個人による金融商品取引に係るセーフティネットに関する次の記述のうち、最も適切なものはどれか。[2023.01]",
        "choice1": "確定拠出年金の加入者が運用の方法として選択した定期預金は、加入者の預金として、預金保険制度による保護の対象となる。",
        "choice2": "日本国内で事業を行う生命保険会社が破綻した場合、生命保険契約者保護機構による補償の対象となる保険契約については、高予定利率契約を除き、原則として、破綻時点の責任準備金等の80％まで補償される。",
        "choice3": "証券会社が破綻し、分別管理が適切に行われていなかったために、一般顧客の資産の一部または全部が返還されない事態が生じた場合、日本投資者保護基金により、補償対象債権に係る顧客資産について一般顧客1人当たり2,000万円を上限として補償される。",
        "choice4": "銀行で購入した投資信託は、日本投資者保護基金による保護の対象となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "セーフティネット",
        "important": ""
    },
    {
        "id": 31,
        "shikenId": 1,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税の基本的な仕組みに関する次の記述のうち、最も適切なものはどれか。[2024.01]",
        "choice1": "所得税では、納税者が申告した所得金額に基づき、納付すべき税額を税務署長が決定する賦課課税方式が採用されている。",
        "choice2": "所得税の課税対象は国内において生じた所得のみであり、国外において生じた所得が課税対象となることはない。",
        "choice3": "所得税における居住者とは、国内に住所を有し、または現在まで引き続いて1年以上居所を有する個人をいう。",
        "choice4": "所得税額の計算において課税総所得金額に乗じる税率には、課税総所得金額が大きくなるにつれて段階的に税率が高くなる超過累進税率が採用されており、その最高税率は30％である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の基本的な仕組み",
        "important": ""
    },
    {
        "id": 32,
        "shikenId": 1,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も不適切なものはどれか。[2022.09]",
        "choice1": "不動産所得の金額は、原則として、「不動産所得に係る総収入金額－必要経費」の算式により計算される。",
        "choice2": "賃貸の用に供している土地の所有者が、当該土地を取得した際に支出した仲介手数料は、当該土地の取得価額に算入されるため、その支払った年分の不動産所得の金額の計算上、必要経費に算入することはできない。",
        "choice3": "個人による不動産の貸付けが事業的規模である場合、その賃貸収入による所得は、事業所得に該当する。",
        "choice4": "借家人が賃貸借の目的とされている居宅の立退きに際して受け取る立退き料（借家権の消滅の対価の額に相当する部分の金額を除く）は、原則として一時所得に該当する。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税における各種所得",
        "important": ""
    },
    {
        "id": 33,
        "shikenId": 1,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の各種所得の金額の計算上生じた次の損失の金額のうち、他の所得の金額と損益通算できないものはどれか。[2023.01]",
        "choice1": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき建物の取得に要した負債の利子に相当する部分の金額",
        "choice2": "生活の用に供していた自家用車を売却したことによる譲渡所得の金額の計算上生じた損失の金額",
        "choice3": "コンサルティング事業を行ったことによる事業所得の金額の計算上生じた損失の金額",
        "choice4": "取得してから5年が経過した山林を伐採して譲渡したことによる山林所得の金額の計算上生じた損失の金額",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算できないもの",
        "important": ""
    },
    {
        "id": 34,
        "shikenId": 1,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。[2023.05]",
        "choice1": "納税者が医師の診療に係る医療費を支払った場合、その全額を医療費控除として総所得金額等から控除することができる。",
        "choice2": "納税者が特定一般用医薬品等（スイッチOTC医薬品等）の購入費を支払った場合、その全額を医療費控除として総所得金額等から控除することができる。",
        "choice3": "納税者が確定拠出年金の個人型年金の掛金を支払った場合、その全額を社会保険料控除として総所得金額等から控除することができる。",
        "choice4": "納税者が国民年金基金の掛金を支払った場合、その全額を社会保険料控除として総所得金額等から控除することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 35,
        "shikenId": 1,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、2025年3月に住宅ローンを利用して住宅を取得し、同年中にその住宅を居住の用に供したものとする。[2024.09]",
        "choice1": "住宅ローン控除の適用を受けるためには、原則として、住宅を取得した日から6ヵ月以内に自己の居住の用に供し、適用を受ける年の12月31日まで引き続き居住していなければならない。",
        "choice2": "住宅ローン控除の適用を受けるためには、納税者のその年分の合計所得金額が3,000万円以下でなければならない。",
        "choice3": "住宅ローンの一部繰上げ返済を行い、借入金の償還期間が当初の契約により定められていた最初に償還した月から10年未満となった場合、残りの控除期間について住宅ローン控除の適用を受けることはできない。",
        "choice4": "新たに取得した住宅を居住の用に供した年に、これまで居住の用に供していた住宅を譲渡して「居住用財産を譲渡した場合の3,000万円の特別控除」の適用を受けた場合、住宅ローン控除の適用を受けることはできない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 36,
        "shikenId": 1,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "法人税の仕組みに関する次の記述のうち、最も適切なものはどれか。[2024.05]",
        "choice1": "法人を設立した場合、設立の日以後1ヵ月以内に、一定の書類を添付した法人設立届出書を納税地の所轄税務署長に提出しなければならない。",
        "choice2": "法人は、法人税の納税地に異動があった場合、原則として、異動届出書を異動前の納税地の所轄税務署長に提出しなければならない。",
        "choice3": "法人税の確定申告書は、原則として、各事業年度終了の日の翌日から1ヵ月以内に、納税地の所轄税務署長に提出しなければならない。",
        "choice4": "期末資本金の額等が1億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年1,000万円以下の部分について軽減税率が適用される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の仕組み",
        "important": ""
    },
    {
        "id": 37,
        "shikenId": 1,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人税における交際費等に関する次の記述のうち、最も適切なものはどれか。[2021.03]",
        "choice1": "得意先への接待のために支出した、参加者1人当たり1万円以下の飲食費は、交際費等から除かれる。",
        "choice2": "カレンダーやタオルを得意先に配るために通常要する費用は、交際費等に該当する。",
        "choice3": "期末資本金の額等が1億円以下の一定の中小法人が支出した交際費等の額のうち、接待飲食費の額の60％相当額を損金の額に算入することができる。",
        "choice4": "期末資本金の額等が1億円以下の一定の中小法人が支出した交際費等の額のうち、定額控除限度額である年1,000万円までの金額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税における交際費等",
        "important": ""
    },
    {
        "id": 38,
        "shikenId": 1,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。[2023.05]",
        "choice1": "土地の譲渡は、非課税取引に該当する。",
        "choice2": "新たに設立した普通法人のうち、事業年度開始の日における資本金の額等が1,000万円以上である法人は、基準期間がない課税期間において消費税の課税事業者となる。",
        "choice3": "基準期間における課税売上高が1億円である課税事業者は、所定の手続きにより、簡易課税制度の適用を受けることができる。",
        "choice4": "課税事業者である個人事業者は、原則として、消費税の確定申告書をその年の翌年3月31日までに納税地の所轄税務署長に提出しなければならない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税",
        "important": ""
    },
    {
        "id": 39,
        "shikenId": 1,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。[2022.05]",
        "choice1": "役員が所有する土地を会社に譲渡した場合、その譲渡価額が適正な時価の2分の1未満であるときは、適正な時価により譲渡所得の金額が計算される。",
        "choice2": "役員が会社に無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その役員の雑所得の収入金額に算入される。",
        "choice3": "会社が所有する建物を適正な時価よりも高い価額で役員に譲渡した場合、その会社の所得の金額の計算上、適正な時価と譲渡対価の差額は、益金の額に算入される。",
        "choice4": "会社が役員に無利息で金銭の貸付けを行った場合、原則として、その会社の所得の金額の計算上、適正な利率により計算した利息相当額が益金の額に算入される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "会社と役員間の取引",
        "important": ""
    },
    {
        "id": 40,
        "shikenId": 1,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "貸借対照表および損益計算書の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。[2024.01]",
        "choice1": "貸借対照表の無形固定資産は、物理的な形態を持たない特許権や商標権等の資産の金額を表示している。",
        "choice2": "貸借対照表の固定負債は、返済期限が決算日の翌日から起算して1年以内に到来しない借入金等の負債の金額を表示している。",
        "choice3": "損益計算書の営業利益は、売上総利益金額から販売費及び一般管理費の合計額を控除した金額を表示している。",
        "choice4": "損益計算書の税引前当期純利益は、経常利益または経常損失の金額に営業外収益・営業外費用を加算・減算した金額を表示している。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "貸借対照表および損益計算書の一般的な特徴",
        "important": ""
    },
    {
        "id": 41,
        "shikenId": 1,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。[2023.09]",
        "choice1": "抵当権の登記の登記事項は、権利部乙区に記録される。",
        "choice2": "区分建物を除く建物に係る登記記録において、床面積は、壁その他の区画の中心線で囲まれた部分の水平投影面積（壁芯面積）により記録される。",
        "choice3": "新築した建物の所有権を取得した者は、その所有権の取得の日から1ヵ月以内に、所有権保存登記を申請しなければならない。",
        "choice4": "登記情報提供サービスでは、登記所が保有する登記情報を、インターネットを使用してパソコン等で確認することができるが、取得した登記情報に係る電子データには登記官の認証文は付されない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の登記や調査に関する次の記述",
        "important": ""
    },
    {
        "id": 42,
        "shikenId": 1,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "民法および借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、借地借家法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載のない特約については考慮しないものとする。[2024.01]",
        "choice1": "賃借人は、建物の引渡しを受けた後の通常の使用および収益によって生じた建物の損耗ならびに経年変化については、賃貸借が終了したときに原状に復する義務を負わない。",
        "choice2": "普通借家契約において、賃借人が賃貸人の同意を得て建物に付加した造作について、賃貸借終了時、賃借人が賃貸人に、その買取りを請求しない旨の特約をした場合、その特約は無効である。",
        "choice3": "定期借家契約を締結するときは、賃貸人は、あらかじめ、賃借人に対し、契約の更新がなく、期間満了により賃貸借が終了することについて、その旨を記載した書面を交付し、または、賃借人の承諾を得て当該書面に記載すべき事項を電磁的方法により提供して、説明しなければならない。",
        "choice4": "定期借家契約において、経済事情の変動があっても賃貸借期間中は賃料を増減額しないこととする特約をした場合、その特約は有効である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "民法および借地借家法（借家）",
        "important": ""
    },
    {
        "id": 43,
        "shikenId": 1,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "宅地建物取引業法に関する次の記述のうち、最も不適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。[2023.05]",
        "choice1": "宅地建物取引業者が建物の貸借の媒介を行う場合、貸主と借主の双方から受け取ることができる報酬の合計額は、当該建物の借賃（消費税等相当額を除く）の2ヵ月分に相当する額に消費税等相当額を加算した額が上限となる。",
        "choice2": "宅地建物取引業者は、自ら売主となる宅地の売買契約の締結に際して、代金の額の10分の2を超える額の手付を受領することができない。",
        "choice3": "宅地建物取引業者が、自ら売主となる宅地の売買契約の締結に際して手付を受領したときは、その手付がいかなる性質のものであっても、買主が契約の履行に着手する前であれば、当該宅地建物取引業者はその倍額を現実に提供して、契約の解除をすることができる。",
        "choice4": "専任媒介契約の有効期間は、3ヵ月を超えることができず、これより長い期間を定めたときは、その期間は3ヵ月とされる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "宅地建物取引業法",
        "important": ""
    },
    {
        "id": 44,
        "shikenId": 1,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。[2023.05]",
        "choice1": "すべての都市計画区域において、都市計画に市街化区域と市街化調整区域の区分（区域区分）を定めなければならない。",
        "choice2": "都市計画区域のうち、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
        "choice3": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築の用に供する目的で行う開発行為は、開発許可を受ける必要はない。",
        "choice4": "土地区画整理事業の施行として行う開発行為は、開発許可を受けなければならない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画法",
        "important": ""
    },
    {
        "id": 45,
        "shikenId": 1,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。[2024.01]",
        "choice1": "建築基準法第42条第2項により道路境界線とみなされる線と道路との間の敷地部分（セットバック部分）は、建蔽率を算定する際の敷地面積に算入することができない。",
        "choice2": "建築物の敷地が2つの異なる用途地域にわたる場合、その全部について、敷地の過半の属する用途地域の建築物の用途に関する規定が適用される。",
        "choice3": "防火地域内にある耐火建築物は、いずれの用途地域内にある場合であっても、建蔽率の制限に関する規定の適用を受けない。",
        "choice4": "商業地域内の建築物には、北側斜線制限（北側高さ制限）は適用されない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法",
        "important": ""
    },
    {
        "id": 46,
        "shikenId": 1,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。[2022.09]",
        "choice1": "区分所有建物ならびにその敷地および附属施設の管理を行うための区分所有者の団体（管理組合）は、区分所有者全員で構成される。",
        "choice2": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
        "choice3": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
        "choice4": "規約を変更するためには、区分所有者および議決権の各4分の3以上の多数による集会の決議が必要となり、この変更が一部の区分所有者の権利に特別の影響を及ぼすべきときは、当該区分所有者の承諾を得なければならない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 47,
        "shikenId": 1,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産取得税に関する次の記述のうち、最も適切なものはどれか。[2025.05]",
        "choice1": "相続人以外の者が、被相続人が作成した遺言による特定遺贈により土地を取得した場合、原則として、不動産取得税が課される。",
        "choice2": "相続人が、被相続人との死因贈与契約に基づき、被相続人の相続開始に伴って土地を取得した場合、原則として、不動産取得税は課されない。",
        "choice3": "土地の所有権を等価交換方式による全部譲渡により取得した場合、原則として、取得者に対して不動産取得税は課されない。",
        "choice4": "所定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定にあたっては、1戸につき最高で1,500万円が価格から控除される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産取得税",
        "important": ""
    },
    {
        "id": 48,
        "shikenId": 1,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も不適切なものはどれか。[2024.09]",
        "choice1": "相続により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の日は、相続人が当該相続を登記原因として所有権移転登記をした日である。",
        "choice2": "譲渡所得の金額の計算上、譲渡した土地の取得費が不明な場合には、譲渡収入金額の5％相当額を取得費とすることができる。",
        "choice3": "土地の譲渡に係る所得が短期譲渡所得に区分される場合、課税短期譲渡所得金額に対して、所得税（復興特別所得税を含む）30.63％、住民税9％の税率により課税される。",
        "choice4": "土地を譲渡する際に支出した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地を譲渡した場合の譲渡所得",
        "important": ""
    },
    {
        "id": 49,
        "shikenId": 1,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の有効活用の手法の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。[2022.05]",
        "choice1": "事業受託方式は、土地の有効活用の企画、建設会社の選定や当該土地上に建設された建物の管理・運営等をデベロッパーに任せ、建設資金の調達や返済は土地所有者が行う方式である。",
        "choice2": "等価交換方式は、土地所有者とデベロッパーの共同事業として、土地所有者が土地を出資し、デベロッパーが建設資金を出資して建物を建て、それぞれの出資比率に応じて土地や建物を取得する方式である。",
        "choice3": "建設協力金方式では、土地所有者が土地の上に建物を建てる際に、事業者が土地所有者に資金を提供するため、当該建物の所有名義は事業者となる。",
        "choice4": "定期借地権方式では、土地所有者は土地を一定期間貸し付けることにより地代収入を得ることができ、当該土地上に建設される建物の建設資金を負担する必要がない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の有効活用の手法",
        "important": ""
    },
    {
        "id": 50,
        "shikenId": 1,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産の投資判断手法等に関する次の記述のうち、最も適切なものはどれか。[2024.05]",
        "choice1": "NOI利回り（純利回り）は、対象不動産から得られる年間の純収益を総投資額で除して算出される利回りであり、不動産の収益性を測る指標である。",
        "choice2": "NPV法（正味現在価値法）による投資判断においては、対象不動産から得られる収益の現在価値の合計額が投資額を下回っている場合、その投資は有利であると判定することができる。",
        "choice3": "DSCR（借入金償還余裕率）は、対象不動産から得られる収益による借入金の返済余裕度を評価する指標であり、対象不動産に係る当該指標の数値が1.0を下回っている場合は、対象不動産から得られる収益だけで借入金を返済することができる。",
        "choice4": "DCF法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の価格を求める手法である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の投資判断手法等",
        "important": ""
    },
    {
        "id": 51,
        "shikenId": 1,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "親族等に係る民法の規定に関する次の記述のうち、最も適切なものはどれか。[2024.05]",
        "choice1": "親族の範囲は、3親等内の血族、配偶者、6親等内の姻族である。",
        "choice2": "兄弟姉妹の子（甥や姪）は、3親等の血族である。",
        "choice3": "配偶者の父母は、2親等の姻族である。",
        "choice4": "子の配偶者は、2親等の姻族である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "親族等に係る民法の規定",
        "important": ""
    },
    {
        "id": 52,
        "shikenId": 1,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "贈与税の申告と納付に関する次の記述のうち、最も適切なものはどれか。[2023.09]",
        "choice1": "贈与税の申告書は、原則として、贈与を受けた年の翌年2月1日から3月15日までの間に、受贈者の納税地の所轄税務署長に提出しなければならない。",
        "choice2": "国税電子申告・納税システム（e-Tax）は、贈与税の申告には対応していない。",
        "choice3": "贈与税を納期限までに納付することが困難である場合、その納付を困難とする金額を限度として延納または物納を申請することができる。",
        "choice4": "贈与税の納付について認められる延納期間は、最長10年である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の申告と納付",
        "important": ""
    },
    {
        "id": 53,
        "shikenId": 1,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "民法上の相続人等に関する次の記述のうち、最も適切なものはどれか。なお、記載のない事項については考慮しないものとする。[2024.01]",
        "choice1": "離婚した元配偶者との間に出生した被相続人の子が当該元配偶者の親権に服している場合、その子は相続人とならない。",
        "choice2": "特別養子縁組による養子は、実方の父母および養親の相続人となる。",
        "choice3": "被相続人の子が廃除により相続権を失った場合、その者に被相続人の直系卑属である子がいるときは、その子（被相続人の孫）は代襲相続人となる。",
        "choice4": "被相続人と婚姻の届出をしていないが、被相続人といわゆる内縁関係にあった者は、被相続人の配偶者とみなされて相続人となる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の相続人等",
        "important": ""
    },
    {
        "id": 54,
        "shikenId": 1,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "遺産分割に関する次の記述のうち、最も適切なものはどれか。[2023.01]",
        "choice1": "適法に成立した遺産分割協議については、共同相続人全員の合意があったとしても、解除することは認められない。",
        "choice2": "代償分割は、現物分割を困難とする事由がある場合に、共同相続人が家庭裁判所に申し立て、その審判を受けることにより認められる。",
        "choice3": "相続財産である不動産を、共同相続人間で遺産分割するために譲渡して換価した場合、その譲渡による所得は、所得税において非課税所得とされている。",
        "choice4": "被相続人は、遺言によって、相続開始の時から5年を超えない期間を定めて、遺産の分割を禁ずることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産分割",
        "important": ""
    },
    {
        "id": 55,
        "shikenId": 1,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "相続税の非課税財産に関する次の記述のうち、最も適切なものはどれか。[2024.01]",
        "choice1": "被相続人の死亡により、相続人が被相続人に支給されるべきであった退職手当金の支給を受けた場合、当該退職手当金の支給が被相続人の死亡後5年以内に確定したものであれば、相続人は、当該退職手当金について死亡退職金の非課税金額の規定の適用を受けることができる。",
        "choice2": "死亡退職金の非課税金額の規定による非課税限度額は、被相続人の死亡が業務上の死亡である場合、被相続人の死亡時における賞与以外の普通給与の3年分に相当する金額である。",
        "choice3": "契約者（＝保険料負担者）および被保険者を被相続人とする生命保険契約に基づき、相続の放棄をした者が受け取った死亡保険金については、死亡保険金の非課税金額の規定は適用されない。",
        "choice4": "死亡保険金の非課税金額の規定による非課税限度額の計算上の相続人の数には、相続の放棄をした者は含まれない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の非課税財産",
        "important": ""
    },
    {
        "id": 56,
        "shikenId": 1,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "民法上の遺言に関する次の記述のうち、最も適切なものはどれか。[2023.09]",
        "choice1": "相続人が自筆証書遺言を発見し、家庭裁判所の検認を受ける前に開封した場合、その遺言は無効となる。",
        "choice2": "遺言者が自筆証書遺言に添付する財産目録をパソコンで作成する場合、当該目録への署名および押印は不要である。",
        "choice3": "公正証書遺言の作成において、遺言者の推定相続人とその配偶者は証人として立ち会うことができない。",
        "choice4": "公正証書遺言は、自筆証書遺言によって撤回することはできず、公正証書遺言によってのみ撤回することができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言",
        "important": ""
    },
    {
        "id": 57,
        "shikenId": 1,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "配偶者に対する相続税額の軽減（以下「配偶者の税額軽減」という）に関する次の記述のうち、最も適切なものはどれか。[2024.09]",
        "choice1": "配偶者の税額軽減の適用を受けた配偶者が相続または遺贈により取得した正味の遺産額が1億6,000万円を超える場合は、その遺産額が配偶者の法定相続分相当額以下であっても、配偶者の納付すべき相続税額は0（ゼロ）とならない。",
        "choice2": "配偶者の税額軽減の適用を受け、納付すべき相続税額が0（ゼロ）となる場合、相続税の申告書を提出する必要はない。",
        "choice3": "相続の放棄をした配偶者は、配偶者の税額軽減の適用を受けることができない。",
        "choice4": "配偶者の税額軽減の適用を受けることができる配偶者は、被相続人と法律上の婚姻の届出をしている者に限られる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "配偶者の税額軽減",
        "important": ""
    },
    {
        "id": 58,
        "shikenId": 1,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税における取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。なお、特定の評価会社の株式には該当しないものとする。[2023.05]",
        "choice1": "類似業種比準方式における比準要素は、1株当たりの配当金額、1株当たりの利益金額および1株当たりの純資産価額（帳簿価額によって計算した金額）である。",
        "choice2": "会社規模が大会社である会社において、中心的な同族株主が取得した株式の価額は、原則として、類似業種比準方式と純資産価額方式の併用方式によって評価する。",
        "choice3": "会社規模が小会社である会社において、中心的な同族株主が取得した株式の価額は、原則として、類似業種比準方式によって評価する。",
        "choice4": "同族株主のいる会社において、同族株主以外の株主が取得した株式の価額は、その会社規模にかかわらず、原則として、純資産価額方式によって評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "取引相場のない株式の評価",
        "important": ""
    },
    {
        "id": 59,
        "shikenId": 1,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "普通住宅地区に所在している下記＜資料＞の宅地の相続税評価額（自用地評価額）として、最も適切なものはどれか。なお、記載のない事項については考慮しないものとする。[2022.05]<br><img src='/img/59_0416.jpg'>",
        "choice1": "85,554千円",
        "choice2": "87,300千円",
        "choice3": "88,200千円",
        "choice4": "90,000千円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の相続税評価額",
        "important": ""
    },
    {
        "id": 60,
        "shikenId": 1,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "会社法に関する次の記述のうち、最も不適切なものはどれか。[2024.01]",
        "choice1": "すべての株式会社は、取締役会を置かなければならない。",
        "choice2": "株式会社において株主は、その有する株式の引受価額を限度として責任を負う。",
        "choice3": "定時株主総会は、毎事業年度終了後一定の時期に招集しなければならないが、臨時株主総会は、必要がある場合にいつでも招集することができる。",
        "choice4": "取締役は、いつでも、株主総会の決議によって解任することができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "会社法に関する記述",
        "important": ""
    },
    {
        "id": 61,
        "shikenId": 2,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "847300,1190945",
        "score": "1,2",
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "Ａさんが、原則として65歳から受給することができる公的年金制度からの老齢給付について、次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、年金額は2026年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br>① 老齢基礎年金の年金額<br>② 老齢厚生年金の年金額<br><img data-image-id=\"I1\" data-asset-id=\"ab21483b-16ba-413b-bdc0-fa46f9d5a7b2\" src='/img/2_1_1776305985757143.png' />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "",
        "choice4": "",
        "choice5": "2309 設例改",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度からの老齢給付",
        "important": ""
    },
    {
        "id": 62,
        "shikenId": 2,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ル,ロ,ニ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「Ａさんおよび妻Ｂさんは、老後の年金収入を増やす方法として、個人型年金に加入することができます。個人型年金は、加入者の指図により掛金を運用し、その運用結果に基づく給付を受け取る制度であり、拠出できる掛金の限度額は、Ａさんの場合は年額144,000円、妻Ｂさんの場合は年額（ ① ）円です。加入者が拠出した掛金は、その全額を所得税の（ ② ）として総所得金額等から控除することができます」<br>Ⅱ 「Ａさんが60歳から個人型年金の老齢給付金を受給するためには、通算加入者等期間が（ ③ ）年以上なければなりません。なお、Ａさんの通算加入者等期間が（ ③ ）年以上である場合、老齢給付金の受給開始時期を、60歳から（ ④ ）歳になるまでの間で選択することができます」<br><img data-image-id=\"I1\" data-asset-id=\"80e96a99-6b84-476d-870d-5ee1f3da3c53\" src='/img/2_2_1776305986424816.png' />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2310 設例改",
        "categoryName": "ライフ",
        "rontenName": "確定拠出年金の個人型年金",
        "important": ""
    },
    {
        "id": 63,
        "shikenId": 2,
        "no": 3,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度等についてアドバイスをした。Ｍさんがアドバイスした次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「Ａさんが希望すれば、66歳以後、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。仮に、Ａさんが70歳で老齢基礎年金の繰下げ支給の申出をした場合、当該年金額の増額率は24％となります」",
        "choice2": "「長女Ｃさんが、2026年11月以降の大学生である期間について国民年金の学生納付特例の適用を受ける場合、長女Ｃさん本人に係る所得要件はありますが、Ａさんおよび妻Ｂさんに係る所得要件はありません」",
        "choice3": "「Ａさんが確定拠出年金の個人型年金の加入後に死亡した場合において、個人別管理資産があるときは、Ａさんの遺族は所定の手続により死亡一時金を受け取ることができます。Ａさんの遺族が受け取る死亡一時金は、所得税と相続税のいずれの課税対象にもなりません」",
        "choice4": "",
        "choice5": "2311 設例改",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度等",
        "important": ""
    },
    {
        "id": 64,
        "shikenId": 2,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、《設例》のデータに基づいて、株式の投資指標について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「Ⅹ社およびＹ社のＲＯＥはいずれも８％を上回っています。一般に、ＲＯＥが高い会社ほど、自己資本の効率的な活用がなされていると判断することができます」",
        "choice2": "「Ⅹ社株式およびＹ社株式のＰＢＲはいずれも１倍を下回っています。一般に、ＰＢＲが低いほど株価は割安と判断されますが、ＰＢＲが１倍を大きく下回る株式は、その企業の資本収益性や成長性に対する投資家の評価が低い可能性があります」",
        "choice3": "「配当性向は、Ⅹ社のほうがＹ社よりも高くなっています。一般に、配当性向が高いほど、株主への利益還元の度合いが高いと考えることができます」",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "金融",
        "rontenName": "株式の投資指標",
        "important": ""
    },
    {
        "id": 65,
        "shikenId": 2,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、株式および債券の売買等に係る税金について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「 Ａさんが特定口座（源泉徴収あり）においてＸ社株式を株価1,500円で500株購入し、購入した年に株価1,700円で全株売却する場合、その他の取引や手数料等を考慮しなければ、売却益となる10万円の20.315％相当額が源泉徴収等されます」",
        "choice2": "「 ＡさんがⅩ社株式やＹ社株式を購入して配当金の支払を受けた場合、その配当金について、申告分離課税を選択して所得税の確定申告をすることにより、配当控除の適用を受けることができます」",
        "choice3": "「 Ｚ社債の利子は、源泉分離課税の対象となり、その支払を受ける際に当該利子額の20.315％相当額が源泉徴収等されることで納税が完結するため、Ⅹ社株式やＹ社株式などの上場株式の譲渡損失の金額と損益通算することはできません」",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "金融",
        "rontenName": "株式・債券の売買等に係る税金",
        "important": ""
    },
    {
        "id": 66,
        "shikenId": 2,
        "no": 6,
        "answerType": 4,
        "groupId": 0,
        "answer": "0.73,0.86",
        "score": "2,2",
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "Ｚ社債を《設例》の〈Ｚ社債に関する資料〉に基づいて購入した場合において、次の①、②を答えなさい（計算過程の記載は不要）。なお、〈答〉は、表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br>また、税金等は考慮しないものとする。<br>① Ｚ社債を償還まで保有した場合の最終利回り（年率・単利）<br>② Ｚ社債を２年後に額面100円当たり99.90円で売却した場合の所有期間利回り（年率・単利）",
        "choice1": "％",
        "choice2": "％",
        "choice3": "",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "金融",
        "rontenName": "債券の利回り",
        "important": ""
    },
    {
        "id": 67,
        "shikenId": 2,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ニ,イ",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「事業所得の金額の計算上、青色申告特別控除として最高（ ① ）万円を控除することができます。（ ① ）万円の青色申告特別控除の適用を受けるためには、事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を法定申告期限内に提出することに加えて、e-Taxによる申告（電子申告）または電子帳簿保存を行う必要があります。なお、確定申告書を法定申告期限後に提出した場合、青色申告特別控除額は最高（ ② ）万円となります」<br>Ⅱ 「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の（ ③ ）年間の繰越控除、純損失の繰戻還付、棚卸資産の評価について低価法を選択できることなどが挙げられます」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"1d5d31be-5916-444f-a1dd-af68ca4ac90f\" src='/img/2_7_1776305986704800.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2305 設例改",
        "categoryName": "タックス",
        "rontenName": "所得税における青色申告制度",
        "important": ""
    },
    {
        "id": 68,
        "shikenId": 2,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選びなさい。",
        "choice1": "「不動産所得の金額の計算上生じた損失の金額のうち、土地の取得に係る負債の利子20万円に相当する部分の金額は、他の所得の金額と損益通算することはできません」",
        "choice2": "「妻Ｂさんの合計所得金額は62万円以下であるため、Ａさんは配偶者控除の適用を受けることができます」",
        "choice3": "「Ａさんが受け取った一時払変額個人年金保険の解約返戻金は、契約から10年以内の解約のため、金融類似商品として、源泉分離課税の対象となります」",
        "choice4": "",
        "choice5": "2306 設例改",
        "categoryName": "タックス",
        "rontenName": "所得税の課税",
        "important": ""
    },
    {
        "id": 69,
        "shikenId": 2,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "4850000,580000,172500",
        "score": "1,1,2",
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-id=\"d9562751-0e9c-42dc-ae10-aa108d84715c\" src='/img/2_9_1776305986941834.png' /><br><img data-image-id=\"I2\" data-asset-id=\"17deb6d7-de48-4e50-adbc-02a1c3554356\" src='/img/2_9_1776305987264942.png' />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "2307 設例改",
        "categoryName": "タックス",
        "rontenName": "所得税の算出税額",
        "important": ""
    },
    {
        "id": 70,
        "shikenId": 2,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "4,801,800",
        "score": "2,2",
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を答えなさい。<br>① 建蔽率の上限となる建築面積<br>② 容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "建築面積と延べ面積の上限",
        "important": ""
    },
    {
        "id": 71,
        "shikenId": 2,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "甲土地の売却に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「甲土地の売却にあたって宅地建物取引業者と専任媒介契約を締結する場合、当該契約の有効期間は２カ月を超えることができませんが、当該契約の有効期間内に甲土地の買主が見つからなかったときは、契約を更新することができます」",
        "choice2": "「甲土地の売却に係る譲渡所得の金額の計算上、取得費は、原則として、Ａさんの父親が甲土地を取得した際の購入代金や購入手数料等の合計額となりますが、その金額が不明である場合、甲土地の売却価額の10％相当額を取得費とすることができます」",
        "choice3": "「甲土地の売却に係る譲渡所得の金額の計算上、『相続財産に係る譲渡所得の課税の特例』（相続税の取得費加算の特例）の適用を受けるためには、甲土地を相続開始のあった日の翌日から相続税の申告期限の翌日以後３年を経過する日までの間に譲渡する必要があります」",
        "choice4": "",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "土地の売却に関する記述",
        "important": ""
    },
    {
        "id": 72,
        "shikenId": 2,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "建設協力金方式の一般的な特徴等に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「建設協力金方式は、ＡさんがⅩ社から建設資金の一部または全部を借り受けて、Ⅹ社の要望に沿った店舗を建設し、その店舗をⅩ社に賃貸する手法です。Ａさんが借り受けた建設資金は、通常、賃料の一部で返済していくことになります」",
        "choice2": "「建設協力金方式では、建設した店舗に係る固定資産税の納税義務はⅩ社が負い、甲土地に係る固定資産税の納税義務はＡさんが負うことになります」",
        "choice3": "「建設協力金方式では、ＡさんがⅩ社に店舗を賃貸した後、その賃貸期間中にＡさんの相続が開始した場合、相続税額の計算上、店舗は貸家として評価され、甲土地は貸宅地として評価されます」",
        "choice4": "",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "建設協力金方式",
        "important": ""
    },
    {
        "id": 73,
        "shikenId": 2,
        "no": 13,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,ロ,リ,チ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "Ａさんの相続・事業承継等に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選びなさい。<br><br>Ⅰ 「円滑な遺産分割を行うため、遺言書の作成をお勧めします。Ａさんが自筆証書遺言を作成する場合、（ ① ）における保管制度を活用することで、遺言書の紛失等を防ぐことができます」<br>Ⅱ 「長男ＣさんがＸ社本社建物とその敷地を相続により取得し、当該敷地（相続税評価額8,000万円）について、特定同族会社事業用宅地等として限度面積まで『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、相続税の課税価格に算入すべき当該敷地の価額は（ ② ）万円となります。なお、自宅敷地とＸ社本社敷地について、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けようとする場合、（ ③ ）」<br>Ⅲ 「長女ＤさんはＡさんの相続開始前に死亡しているため、孫ＥさんはＡさんの相続において代襲相続人となります。孫Ｅさんが相続によりＡさんの財産を取得した場合、相続税額の２割加算の対象と（ ④ ）」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"0cda7137-4b24-4cfd-9732-74a8ddab34e7\" src='/img/2_13_1776305987650344.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2405,
        "categoryName": "相続",
        "rontenName": "相続・事業承継等に関する語句または数値",
        "important": ""
    },
    {
        "id": 74,
        "shikenId": 2,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "遺言に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「遺産分割をめぐる争いを防ぐ手段として、遺言書の作成をお勧めします。公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成するものですが、推定相続人である妻Ｂさんや長男Ｄさんだけでなく、孫Ｅさんも証人になることはできません」",
        "choice2": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局に保管された自筆証書遺言は、遺言者の相続開始後、家庭裁判所における検認が不要となります」",
        "choice3": "「遺言者は、遺言において遺言執行者を指定することができます。推定相続人は、未成年者および破産者に該当しない場合であっても、遺言執行者になることができませんので、遺言執行者を指定する場合は、信頼できる知人等に依頼することをご検討ください」",
        "choice4": "",
        "choice5": 2405,
        "categoryName": "相続",
        "rontenName": "遺言に関する記述",
        "important": ""
    },
    {
        "id": 75,
        "shikenId": 2,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "480,010,254,950",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "現時点（本年５月26日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、課税遺産総額（相続税の課税価格の合計額－遺産に係る基礎控除額）は２億3,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-id=\"e322074f-38db-4d3e-8a61-6ae20107650b\" src='/img/2_15_1776305988009014.png' /><br><img data-image-id=\"I2\" data-asset-id=\"8c996abd-41a8-498f-b4f7-57096426dbac\" src='/img/2_15_1776305988331779.png' />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": 2405,
        "categoryName": "相続",
        "rontenName": "相続税の総額",
        "important": ""
    },
    {
        "id": 76,
        "shikenId": 3,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "792579,322438,20",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが受給することができる公的年金制度からの老齢給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な数値を答えなさい。年金額の計算にあたっては、《設例》の〈Ａさんとその家族に関する資料〉および下記の〈資料〉に基づくこと。なお、年金額は2026年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br>Ⅰ 「Ａさんが65歳に達すると、老齢基礎年金および老齢厚生年金の受給権が発生します。Ａさんが65歳から受給することができる老齢基礎年金の額は、（ ① ）円となります」<br>Ⅱ 「Ａさんが65歳から受給することができる老齢厚生年金の額は、（ ② ）円となります。なお、Ａさんの厚生年金保険の被保険者期間は（ ③ ）年以上ありませんので、老齢厚生年金の額に配偶者に係る加給年金額の加算はありません」<br><img data-image-id=\"I1\" data-asset-id=\"542b7d51-3dfa-4a65-b4b9-a591e7455cd9\" src='/img/3_1_1776312926772446.png' />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "年",
        "choice4": "",
        "choice5": "2405 設例改",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度からの老齢給付",
        "important": ""
    },
    {
        "id": 77,
        "shikenId": 3,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ホ,リ",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、小規模企業共済制度について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>「小規模企業共済制度は、Ａさんのような個人事業主が廃業等した場合に必要となる資金を準備しておくための共済制度です。毎月の掛金は、1,000円から（ ① ）円までの範囲内で、500円単位で選択することができます。支払った掛金は、税法上、（ ② ）の対象となります。<br>共済金は、加入者に廃業等の事由が生じた場合に、掛金納付月数等に応じて支払われます。共済金の受取方法には、『一括受取り』『分割受取り』『一括受取りと分割受取りの併用』があります。『一括受取り』の共済金（死亡事由以外）は、税法上、（ ③ ）として課税対象となります。<br>なお、掛金納付月数が240カ月未満で任意解約した場合は、解約手当金の額が掛金合計額を下回りますので、早期の解約はお勧めできません」<br><img data-image-id=\"I1\" data-asset-id=\"1c3b962c-ac3b-42a7-b0c9-a1e549ecd427\" src='/img/3_2_1776312927732142.png' />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2405 設例改",
        "categoryName": "ライフ",
        "rontenName": "小規模企業共済制度",
        "important": ""
    },
    {
        "id": 78,
        "shikenId": 3,
        "no": 3,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1,2",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、老後の収入を増やすことができる各種制度について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「Ａさんは、国民年金の定額保険料に上乗せして、付加保険料を納付することができます。仮に、Ａさんが付加保険料を200月納付し、65歳から老齢基礎年金を受給する場合、老齢基礎年金の額に付加年金として年額80,000円が上乗せされます」",
        "choice2": "「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。加入は口数制となっており、１口目は２種類の終身年金（Ａ型・Ｂ型）のいずれかを選択します」",
        "choice3": "「国民年金基金の１口目の給付には、国民年金の付加年金相当が含まれているため、Ａさんが国民年金基金に加入した場合、国民年金の付加保険料を納付することはできません」",
        "choice4": "「国民年金の定額保険料や付加保険料を前納した場合、前納期間に応じて保険料の割引がありますが、国民年金基金の掛金については、前納による割引制度はありません」",
        "choice5": "2405 設例改",
        "categoryName": "ライフ",
        "rontenName": "老後の収入を増やす各種制度",
        "important": ""
    },
    {
        "id": 79,
        "shikenId": 3,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、生命保険の見直しについて説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「Ａさんが65歳になると、公的介護保険の第１号被保険者となります。第１号被保険者は、要介護状態または要支援状態となった原因が特定疾病によって生じたものでなければ、公的介護保険の保険給付は受けられませんので、民間の介護保険で備えておくことが重要です」",
        "choice2": "「現在加入している生命保険の死亡保険金額を減額し、提案を受けた生命保険に加入することも検討事項の１つです。現時点でのＡさんの必要保障額を算出し、適正な死亡保険金額を把握することから保障内容の見直しを始めることをお勧めします」",
        "choice3": "「現在加入している生命保険を契約転換して、転換後契約にＹ生命保険が取り扱っている介護保障を目的とした特約を付加する方法も考えられます。転換後契約の保険料は、転換前契約の加入時の年齢により算出されるため、新規に加入する場合と比較して、保険料負担を抑えることができます」",
        "choice4": "",
        "choice5": "2409 設例改",
        "categoryName": "保険（個人）",
        "rontenName": "生命保険の見直し",
        "important": ""
    },
    {
        "id": 80,
        "shikenId": 3,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「公的介護保険の保険給付は、主に訪問介護や通所介護（デイサービス）などの現物給付による介護サービスであるため、自宅の改修費用などの多額の出費に備え、一定額を介護一時金で準備しておくことは検討に値します」",
        "choice2": "「妻ＢさんがＡさんに代わって介護一時金を受け取った場合、当該一時金は一時所得の収入金額として所得税の課税対象となります」",
        "choice3": "「介護年金終身保障保険には、Ａさんだけでなく、妻Ｂさんが加入することも検討に値します。介護年金終身保障保険は、保険金額や保険料払込期間等、同じ内容で設計した場合、女性のほうが男性よりも毎回の保険料は割安になります」",
        "choice4": "",
        "choice5": "2409 設例改",
        "categoryName": "保険（個人）",
        "rontenName": "生命保険の保障内容と課税関係",
        "important": ""
    },
    {
        "id": 81,
        "shikenId": 3,
        "no": 6,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,ロ,リ,ル",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、ＡさんがＸ社を定年退職した後の公的医療保険制度の取扱いについて説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>「ＡさんがＸ社を定年退職し、その後再就職しない場合、公的医療保険については、全国健康保険協会管掌健康保険に任意継続被保険者として加入する、国民健康保険に加入するなどの方法があります。<br>任意継続被保険者となるためには、原則として、ＡさんがＸ社を退職した日の翌日から（ ① ）日以内に、Ａさんの住所地を管轄する全国健康保険協会の都道府県支部に対して資格取得の申出を行う必要があります。<br>任意継続被保険者として健康保険に加入することができる期間は、最長（ ② ）年間です。任意継続被保険者の保険料は、原則として、退職時の標準報酬月額に所定の保険料率を乗じた額となり、その（ ③ ）が自己負担となります。ただし、2026年度において、退職時の標準報酬月額が32万円を超えていた場合は、32万円の標準報酬月額により算出した保険料となります。なお、Ａさんが任意継続被保険者となり、妻ＢさんがＡさんの健康保険の被扶養者となる場合、妻Ｂさんの保険料を（ ④ ）」<br><br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"6b0ccc75-8aaf-4f9b-b590-ddfd8dcb81ed\" src='/img/3_6_1776312928111080.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2409 設例改",
        "categoryName": "保険（個人）",
        "rontenName": "公的医療保険制度の取扱い",
        "important": ""
    },
    {
        "id": 82,
        "shikenId": 3,
        "no": 7,
        "answerType": 4,
        "groupId": 0,
        "answer": "19,902,005",
        "score": "1,2",
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "仮に、Ｘ社がＡさんに役員退職金6,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を答えなさい。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を36年９カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br>① 退職所得控除額<br>② 退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": 2301,
        "categoryName": "保険（法人）",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 83,
        "shikenId": 3,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料＞の長期平準定期保険について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「当該生命保険を現時点で解約した場合、Ｘ社はそれまで資産計上していた前払保険料6,600万円を取り崩して、解約返戻金5,200万円との差額1,400万円を雑損失として経理処理します」",
        "choice2": "「Ａさんの勇退時に当該生命保険を払済終身保険に変更し、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義を変更することで、Ｘ社は終身保険契約を役員退職金の一部としてＡさんに現物支給することができます」",
        "choice3": "「当該生命保険を現時点で払済終身保険に変更した場合、変更した事業年度において雑損失が計上されます。したがって、変更した事業年度の利益を減少させる効果があります」",
        "choice4": "「Ｘ社が契約者貸付制度を利用し、契約者貸付金を受け取った場合、その全額を雑収入として益金の額に算入します」",
        "choice5": 2301,
        "categoryName": "保険（法人）",
        "rontenName": "長期平準定期保険",
        "important": ""
    },
    {
        "id": 84,
        "shikenId": 3,
        "no": 9,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "Ｍさんは、長男Ｂさんに対して、生命保険の活用方法について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「経営者が要介護状態あるいは重度の疾患等で長期間不在となった場合、業績が悪化してしまう可能性も考えられます。そのため、長男Ｂさんが重い病気等になった場合にＸ社が一時金を受け取ることができる生前給付タイプの生命保険に加入されることも検討事項の１つとなります」",
        "choice2": "「保険期間10年の定期保険は、長期平準定期保険に比べて保険料が割安なうえ、保険期間の途中で解約することで、多額の解約返戻金を受け取ることができるため、長男Ｂさんの役員（生存）退職金を準備する方法として適しています」",
        "choice3": "「役員・従業員の退職金準備のために、養老保険の福利厚生プランを活用する方法があります。契約者をＸ社、被保険者を役員・従業員全員、死亡保険金受取人を役員・従業員の遺族、満期保険金受取人をＸ社とする養老保険に加入することにより、支払保険料の全額を福利厚生費として損金の額に算入することができます」",
        "choice4": "",
        "choice5": 2301,
        "categoryName": "保険（法人）",
        "rontenName": "生命保険の活用方法",
        "important": ""
    },
    {
        "id": 85,
        "shikenId": 3,
        "no": 10,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「不動産所得の金額の計算上生じた損失の金額のうち、当該不動産所得を生ずべき土地の取得に係る負債の利子20万円に相当する部分の金額は、他の所得の金額と損益通算することはできません」",
        "choice2": "「Ａさんが受け取った一時払変額個人年金保険の解約返戻金は、一時所得の収入金額として総合課税の対象になります」",
        "choice3": "「Ａさんが本年分の所得税の確定申告をするときに、納税地の所轄税務署長に青色申告承認申請書を提出すれば、本年分の総所得金額から、青色申告特別控除額を控除することができます」",
        "choice4": "",
        "choice5": "2305 設例改",
        "categoryName": "タックス",
        "rontenName": "所得税の課税",
        "important": ""
    },
    {
        "id": 86,
        "shikenId": 3,
        "no": 11,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,ト,ニ",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「 Ａさんの合計所得金額は（ ① ）万円以下であるため、Ａさんは38万円の配偶者控除の適用を受けることができます。仮に、Ａさんの合計所得金額が（ ① ）万円を超えると、配偶者控除の額は段階的に縮小し、合計所得金額が（ ② ）万円を超えると、適用を受けることができません」<br>Ⅱ 「Ａさんが適用を受けることができる扶養控除の額は、（ ③ ）万円です」<br><img data-image-id=\"I1\" data-asset-id=\"2a5169d1-9227-4804-b8c7-f65100278fcc\" src='/img/3_11_1776312928480090.png' />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2305 設例改",
        "categoryName": "タックス",
        "rontenName": "所得控除に関する数値",
        "important": ""
    },
    {
        "id": 87,
        "shikenId": 3,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "6150000,40000,242500",
        "score": "1,1,2",
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-id=\"990f10ce-87b2-4087-b026-c57b128f0ce6\" src='/img/3_12_1776312928728833.png' /><br><img data-image-id=\"I2\" data-asset-id=\"c01bc03f-7556-4340-bb47-6727236910c3\" src='/img/3_12_1776312929197054.png' /><br><img style='width: 400px !important' data-image-id=\"I3\" data-asset-id=\"b28e0b6b-e5e6-4deb-b92e-f2fc28281942\" src='/img/3_12_1776312929743239.png' />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "2305 設例改",
        "categoryName": "タックス",
        "rontenName": "所得税の算出税額",
        "important": ""
    },
    {
        "id": 88,
        "shikenId": 3,
        "no": 13,
        "answerType": 4,
        "groupId": 0,
        "answer": "480,053,409,220",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "現時点（本年１月28日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は４億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img  data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"3b541960-3621-4f05-b588-ec94dacd895c\" src='/img/3_1123817.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "相続",
        "rontenName": "相続税の総額",
        "important": ""
    },
    {
        "id": 89,
        "shikenId": 3,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "Ａさんの相続に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
        "choice1": "「遺産分割をめぐる争いを防ぐ手段として、遺言書の作成をお勧めします。自筆証書遺言については、法務局における保管制度がありますが、当該制度を利用するためには証人２人以上の立会いが必要です」",
        "choice2": "「遺言により、相続財産の大半を妻Ｂさんおよび長男Ｃさんが相続した場合、長女Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分を算定するための財産の価額が４億円である場合、長女Ｄさんの遺留分の金額は１億円となります」",
        "choice3": "「妻Ｂさんが受け取る一時払終身保険の死亡保険金（2,000万円）は、みなし相続財産として相続税の課税対象となりますが、死亡保険金の非課税金額の規定の適用を受けることで、相続税の課税価格に算入される金額は、500万円となります」",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "相続",
        "rontenName": "相続に関する記述",
        "important": ""
    },
    {
        "id": 90,
        "shikenId": 3,
        "no": 15,
        "answerType": 6,
        "groupId": 0,
        "answer": "ニ,ト,リ,ハ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "父Ｃさんの相続に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br>Ⅰ<br>「父Ｃさんが死亡した年分の所得税について、確定申告書を提出しなければならない場合に該当するときは、相続人は、原則として、相続の開始があったことを知った日の翌日から（ ① ）カ月以内に準確定申告を行わなければなりません」<br>Ⅱ<br>「相続税の申告書は、原則として、相続の開始があったことを知った日の翌日から（ ② ）カ月以内に提出する必要があります。申告書の提出先は、（ ③ ）を所轄する税務署長です」<br>Ⅲ<br>「相続により不動産の所有権を取得した相続人は、原則として、自己のために相続の開始があったことを知り、かつ、その不動産の所有権を取得したことを知った日から（ ④ ）年以内に、その不動産について相続登記の申請をする必要があります」<br><img data-image-id=\"I1\" data-asset-id=\"ee578833-ce7d-444c-be77-a9423d40ca3b\" src='/img/3_15_1776312930308701.png' />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2505,
        "categoryName": "相続",
        "rontenName": "相続に関する穴埋め",
        "important": ""
    },
    {
        "id": 91,
        "shikenId": 4,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,1,2",
        "score": "1,1,1,1",
        "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）は、ファイナンシャル・プランニング業務を行ううえで関連業法等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。",
        "question2": "",
        "choice1": "生命保険募集人・保険仲立人の登録を受けていないＦＰが、顧客が持参したパンフレットの変額個人年金保険について商品説明を行った。",
        "choice2": "弁護士資格を有していないＦＰ（遺言者や公証人と利害関係はない成年者）が、顧客から依頼されて公正証書遺言の証人となり、顧客から適正な報酬を受け取った。",
        "choice3": "税理士資格を有していないＦＰが、参加費有料の相続対策セミナーを開催し、仮定の事例に基づく一般的な相続税対策について解説した。",
        "choice4": "投資助言・代理業の登録を受けていないＦＰが、顧客の相談を有償で受け、顧客自身が持参した投資信託の運用報告書の内容を確認し、この投資信託の価値等の分析に基づいて、解約するよう助言した。",
        "choice5": 2301,
        "categoryName": "ライフ",
        "rontenName": "FPと関連業法",
        "important": ""
    },
    {
        "id": 92,
        "shikenId": 4,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "｢金融サービスの提供に関する法律（以下「金融サービス提供法」という）」に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "金融サービス提供法は、金融商品販売業者等が金融商品の販売またはその代理もしくは媒介に際し、顧客に対し説明すべき事項等を定めること等により、顧客の保護を図る法律である。",
        "choice2": "金融サービス提供法は、「金融商品の販売等に関する法律（金融商品販売法）」が改称された法律である。",
        "choice3": "投資信託等の売買の仲介を行うＩＦＡ（Independent Financial Advisor＝独立系ファイナンシャル・アドバイザー）は、金融サービス提供法が適用される。",
        "choice4": "投資は投資者自身の判断と責任において行うべきであり、金融サービス提供法では、金融商品販売業者等が重要事項の説明義務を怠ったことで顧客に損害が生じたとしても、金融商品販売業者等は損害賠償責任を負うわけではない。",
        "choice5": 2301,
        "categoryName": "ライフ",
        "rontenName": "金融サービス提供法",
        "important": ""
    },
    {
        "id": 93,
        "shikenId": 4,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "大下さんは、保有しているＲＴ投資信託（追加型国内公募株式投資信託）の収益分配金を本年４月に受け取った。ＲＴ投資信託の運用状況が下記＜資料＞のとおりである場合、収益分配後の個別元本として、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"a6079e63-e7c7-424b-a0f9-ce88dc748080\" src='/img/4_3_1776850280464499.png'>",
        "question2": "",
        "choice1": "１１,５６０円",
        "choice2": "１１,６００円",
        "choice3": "１１,６８０円",
        "choice4": "１１,７２０円",
        "choice5": 2405,
        "categoryName": "金融",
        "rontenName": "投資信託の個別元本",
        "important": ""
    },
    {
        "id": 94,
        "shikenId": 4,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "大津さんは、投資信託への投資を検討するに当たり、ＦＰの細井さんから候補である３ファンドの過去３年間の運用パフォーマンスについて説明を受けた。ＦＰの細井さんが下記＜資料＞に基づいて説明した内容の空欄（ア）～（ウ）にあてはまる語句および数値の組み合わせとして、最も適切なものはどれか。<br><br><img data-image-id=\"I2\"  data-asset-scope=\"data_check\" data-asset-id=\"a1e15261-6ce5-4c8d-a6be-ab532ab875fe\" src='/img/4_4_1776850280936764.png'>",
        "question2": "",
        "choice1": "（ア）ＫＸファンド （イ）ＫＹファンド （ウ）１.５０",
        "choice2": "（ア）ＫＹファンド （イ）ＫＺファンド （ウ）０.４５",
        "choice3": "（ア）ＫＺファンド （イ）ＫＸファンド （ウ）０.８０",
        "choice4": "（ア）ＫＺファンド （イ）ＫＹファンド （ウ）１.２５",
        "choice5": 2405,
        "categoryName": "金融",
        "rontenName": "シャープレシオ",
        "important": ""
    },
    {
        "id": 95,
        "shikenId": 4,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "下記＜資料＞は、有馬さんが同一の特定口座内で行ったＲＡ株式会社の株式の取引等に係る明細である。有馬さんが２０×４年３月４日に売却した５,０００株について、譲渡所得の取得費の計算の基礎となる１株当たりの取得価額として、正しいものはどれか。なお、消費税その他記載のない事項については一切考慮しないものとする。<br><br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"9057a155-bb8a-4dee-a34b-47f144285f60\" src='/img/4_5_1776850281540979.png'>",
        "question2": "",
        "choice1": "８００円",
        "choice2": "９２０円",
        "choice3": "９６０円",
        "choice4": "１,０４０円",
        "choice5": 2405,
        "categoryName": "金融",
        "rontenName": "譲渡所得の計算",
        "important": ""
    },
    {
        "id": 96,
        "shikenId": 4,
        "no": 6,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "question1": "下記＜資料＞は、香川さんが購入を検討している個人向け国債の商品概要の一部である。個人向け国債に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。なお、問題作成の都合上、一部を「＊＊＊」にしてある。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"5d453802-fcbe-41e7-b180-cf42a14a8546\" src='/img/4_6_1776850281927187.png'>",
        "question2": "",
        "choice1": "変動１０年国債は、金利がゼロ％となることがある。",
        "choice2": "個人向け国債の購入単価（販売価格）は、最低１万円から１万円単位である。",
        "choice3": "個人向け国債は、発行後６ヵ月経過すれば、いつでも中途換金することができる。",
        "choice4": "個人が募集時に購入できる日本国債は、個人向け国債のみである。",
        "choice5": 2405,
        "categoryName": "金融",
        "rontenName": "個人向け国債",
        "important": ""
    },
    {
        "id": 97,
        "shikenId": 4,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "雅之さんが２０×１年から２０×３年の間に行った国内公募追加型株式投資信託ＲＱファンドの取引は、下記＜資料＞のとおりである。２０×３年末時点におけるＲＱファンドの個別元本（１万口当たり）として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"535efa79-b913-4ec7-93ed-56eda1621424\" src='/img/4_7_1776850282378887.png'>",
        "question2": "",
        "choice1": "１０,５００円",
        "choice2": "１０,７３１円",
        "choice3": "１１,０００円",
        "choice4": "１１,２４２円",
        "choice5": 2401,
        "categoryName": "金融",
        "rontenName": "投資信託の個別元本",
        "important": ""
    },
    {
        "id": 98,
        "shikenId": 4,
        "no": 8,
        "answerType": 9,
        "groupId": 0,
        "answer": "172.8",
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の甲土地に建物を建てる場合の建築面積の最高限度を計算しなさい。<br>なお、＜資料＞に記載のない条件については一切考慮しないこととする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"f0cdfb65-578f-4d68-8428-adbc608c7cdf\" src='/img/4_8_1776850282808261.png'>",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2205,
        "categoryName": "不動産",
        "rontenName": "建築面積の最高限度",
        "important": ""
    },
    {
        "id": 99,
        "shikenId": 4,
        "no": 9,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,4,6,9",
        "score": "1,1,1,1",
        "question1": "鶴見さんは、ＦＰで税理士でもある榎田さんに不動産に係る固定資産税について質問をした。下記の空欄（ア）～（エ）にあてはまる適切な語句を語群の中から選びなさい。なお、同じ番号を何度選んでもよいものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"3fcc479e-8cd9-4edf-90df-c1bea4a50bfb\" src='/img/4_9_1776850283441146.png'><br>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "固定資産税",
        "important": ""
    },
    {
        "id": 100,
        "shikenId": 4,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "伊丹さんは、自身の居住用財産である土地・建物の譲渡を予定しており、ＦＰで税理士でもある妹尾さんに居住用財産を譲渡した場合の３,０００万円特別控除の特例（以下「本特例」という）について質問をした。下記＜資料＞に基づく本特例に関する次の記述のうち、最も不適切なものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"dd210f7e-efdb-4a91-b694-85d24d09342d\" src='/img/4_10_1776850284073981.png'>",
        "question2": "",
        "choice1": "「２×２４年１０月３１日に伊丹さんが家族と共に居住の用に供さなくなった場合、その日から２×２７年１２月３１日までに譲渡しなければ、本特例の適用を受けることはできません。」",
        "choice2": "「２×２４年中に譲渡する場合、伊丹さんの２×２４年の合計所得金額が２,０００万円を超えるときは、本特例の適用を受けることはできません。」",
        "choice3": "「２×２４年中に譲渡する場合、譲渡先が伊丹さんの子であるときは、本特例の適用を受けることはできません。」",
        "choice4": "「２×２４年中に譲渡する場合、伊丹さんが２×２２年に本特例の適用を受けていたときは、本特例の適用を受けることはできません。」",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "3,000万円の特別控除の特例",
        "important": ""
    },
    {
        "id": 101,
        "shikenId": 4,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "工藤さんは、下記＜資料＞の投資用マンションについて購入を検討しており、ＦＰの住吉さんに質問をした。下記＜資料＞に基づく次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については一切考慮しないものとし、計算結果について、小数点以下の端数が生じた場合は小数点以下第３位を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"c2c9ec7c-0982-401e-84b5-c3e879656da1\" src='/img/4_11_1776850284514220.png'><br>",
        "question2": "",
        "choice1": "（ア）４.２５％ （イ）元金部分 （ウ）利息部分",
        "choice2": "（ア）４.７１％ （イ）元金部分 （ウ）利息部分",
        "choice3": "（ア）４.２５％ （イ）利息部分 （ウ）元金部分",
        "choice4": "（ア）４.７１％ （イ）利息部分 （ウ）元金部分",
        "choice5": 2409,
        "categoryName": "不動産",
        "rontenName": "投資用マンションの購入",
        "important": ""
    },
    {
        "id": 102,
        "shikenId": 4,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "公的な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"7c18d2b7-434d-4761-a048-d20a9bfcf24f\" src='/img/4_12_1776850285168169.png'>",
        "question2": "",
        "choice1": "（ア）国税庁 （イ）４月１日 （ウ）７割",
        "choice2": "（ア）国税庁 （イ）７月１日 （ウ）８割",
        "choice3": "（ア）市町村 （イ）４月１日 （ウ）８割",
        "choice4": "（ア）市町村 （イ）７月１日 （ウ）７割",
        "choice5": 2505,
        "categoryName": "不動産",
        "rontenName": "公的な土地の評価",
        "important": ""
    },
    {
        "id": 103,
        "shikenId": 4,
        "no": 13,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,6,5",
        "score": "1,1,1",
        "question1": "宮本亜紀さん（３７歳）は医療保険への加入を検討しており、下記＜資料１＞＜資料２＞の２つの商品内容を比較している。次の記述の空欄（ア）～（ウ）にあてはまる適切な語句を語群の中から選びなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"f2ab536c-04fc-406b-ae1a-15e727082247\" src='/img/4_13_1776850285775553.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"52ca33bb-f9b0-4fec-9b4d-686468bb2b42\" src='/img/4_13_1776850286711827.png'><br>・宮本さんが、交通事故により事故当日から４日間継続して入院し、その間に約款に定められた所定の手術（公的医療保険制度の対象となる所定の手術であり、医療治療保険Ａにおける給付倍率は２倍）を受けた場合、保険会社から支払われる給付金の合計は、終身医療保険Ｂより医療治療保険Ａの方が（ ア ）。<br>・宮本さんが、骨折により８日間継続して入院し、退院から１ヵ月後に肺炎で５日間継続して入院した場合、保険会社から支払われる保険金・給付金の合計は、終身医療保険Ｂより医療治療保険Ａの方が（ イ ）。<br>・宮本さんが、肺がんと診断確定され、先進医療に該当する重粒子線治療（技術料３１４万円）を受けた。７日間継続して入院し、重粒子線治療以外の治療は行わなかった場合、保険会社から支払われる保険金・給付金の合計は、終身医療保険Ｂより医療治療保険Ａの方が（ ウ ）。<br><img data-image-id=\"I3\" / data-asset-scope=\"content_extraction\" data-asset-id=\"c1f1b892-6064-4a0e-ac2e-617f196a01cd\" src='/img/4_13_1776850287823408.png'>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2405,
        "categoryName": "リスク",
        "rontenName": "保険提案書 保険金の金額",
        "important": ""
    },
    {
        "id": 104,
        "shikenId": 4,
        "no": 14,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "question1": "広尾吉弘さんが契約している下記＜資料＞の生命保険に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。なお、吉弘さんの家族構成は以下のとおりであり、課税対象となる保険金はいずれも基礎控除額を超えているものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"aed15b06-f556-46a0-b34d-4e21b98368a6\" src='/img/4_14_1776850288204952.png' style='width:380px !important'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"507cf594-bb5f-49d9-bb95-005e629ef5eb\" src='/img/4_14_1776850288622942.png'>",
        "question2": "",
        "choice1": "終身保険Ａから真紀さんが受け取る死亡保険金は、相続税の課税対象となる。",
        "choice2": "特定疾病保障保険Ｂから吉弘さんが受け取る死亡保険金は、相続税の課税対象となる。",
        "choice3": "収入保障保険Ｃから香菜さんが受け取る収入保障年金は、吉弘さんの死亡時に年金受給権として相続税の課税対象となり、２年目以降に受け取る収入保障年金は非課税部分と課税部分に分かれ、課税部分は所得税（雑所得）および住民税の課税対象となる。",
        "choice4": "医療保険Ｄから吉弘さんが受け取る入院給付金・手術給付金は、所得税（一時所得）および住民税の課税対象となる。",
        "choice5": 2405,
        "categoryName": "リスク",
        "rontenName": "生命保険の課税関係",
        "important": ""
    },
    {
        "id": 105,
        "shikenId": 4,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "下記＜資料＞は、藤原さんが契約した生命保険の契約の流れを示したものである。この保険契約の責任開始日（保障が開始する日）として、最も適切なものはどれか。なお、責任開始日（期）に関する特約等はない契約であり、保険料は月払いとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"f4e72857-c99f-4acd-8f63-c29c007764b7\" src='/img/4_15_1776850289187735.png'>",
        "question2": "",
        "choice1": "２×２４年３月 ８日",
        "choice2": "２×２４年３月１７日",
        "choice3": "２×２４年３月２３日",
        "choice4": "２×２４年４月 １日",
        "choice5": 2405,
        "categoryName": "リスク",
        "rontenName": "生命保険責任開始日",
        "important": ""
    },
    {
        "id": 106,
        "shikenId": 4,
        "no": 16,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,1,2",
        "score": "1,1,1,1",
        "question1": "吉田さん（４６歳）が自身を記名被保険者として契約している下記＜資料＞の自動車保険に関するＦＰの馬場さんが行った次の（ア）～（エ）の説明のうち、適切なものには○、不適切なものには×を選択しなさい。なお、＜資料＞に記載のない特約については考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"631ddb66-ec2e-4997-b053-b33ad6f0b4c4\" src='/img/4_16_1776850289606976.png'>",
        "question2": "",
        "choice1": "「台風による飛来物が衝突して被保険自動車が損害を被った場合、その車両損害は補償の対象になりません。」",
        "choice2": "「吉田さんが被保険自動車を運転中に、同乗していた友人が事故で死傷した場合、人身傷害保険から支払われる保険金とは別に、搭乗者傷害保険からも保険金を受け取ることができます。」",
        "choice3": "「実家を出て一人暮らしをしている吉田さんの長女（未婚、１８歳）が、帰省中に被保険自動車を運転して対物事故を起こした場合、補償の対象になります。」",
        "choice4": "「吉田さんが、所有する自動二輪車（総排気量２５０ｃｃ）を運転中に事故を起こして他人にケガを負わせてしまった場合、ファミリーバイク特約の補償の対象となります。」",
        "choice5": 2405,
        "categoryName": "リスク",
        "rontenName": "自動車保険証券",
        "important": ""
    },
    {
        "id": 107,
        "shikenId": 4,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "義博さんは、生命保険の解約返戻金について、ＦＰの高倉さんに質問をした。高倉さんが、生命保険の解約返戻金相当額について説明する際に使用した下記の＜イメージ図＞のうち、一般的な低解約返戻金型終身保険の解約返戻金相当額の推移に係る図として、最も適切なものはどれか。<br>＜イメージ図＞",
        "question2": "",
        "choice1": "<img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"401709b5-dcb4-414a-8785-7460bb134f62\" src='/img/4_17_1776850290481212.png' style='width:300px !important'>",
        "choice2": "<img style='width:300px !important' data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"d3f8b1af-3b6a-435f-88ca-15aaa2dc9441\" src='/img/4_17_1776850290872431.png'>",
        "choice3": "<img style='width:300px !important' data-image-id=\"I3\" data-asset-scope=\"data_check\" data-asset-id=\"105e6735-968f-45a5-8d9f-42185d15416f\" src='/img/4_17_1776850291239766.png'>",
        "choice4": "<img style='width:300px !important' data-image-id=\"I4\" data-asset-scope=\"data_check\" data-asset-id=\"4c385d9a-8f35-4e4d-822f-f58ee6a68c31\" src='/img/4_17_1776850291615918.png'>",
        "choice5": 2305,
        "categoryName": "リスク",
        "rontenName": "解約返戻金相当額の推移に係る図",
        "important": ""
    },
    {
        "id": 108,
        "shikenId": 4,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "会社員の榎田さんが本年中に支払った医療費等が下記＜資料＞のとおりである場合、榎田さんの本年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、榎田さんの本年分の所得は、給与所得６１０万円のみであるものとし、榎田さんは妻および母と生計を一にしている。また、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については考慮せず、保険金等により補てんされる金額はないものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"e1c06595-67a9-4ac6-b583-79d52a2444a5\" src='/img/4_18_1776850291973220.png'>",
        "question2": "",
        "choice1": "４３,０００円",
        "choice2": "４６３,０００円",
        "choice3": "４９３,０００円",
        "choice4": "５５０,０００円",
        "choice5": 2309,
        "categoryName": "タックス",
        "rontenName": "医療費控除の金額",
        "important": ""
    },
    {
        "id": 109,
        "shikenId": 4,
        "no": 19,
        "answerType": 9,
        "groupId": 0,
        "answer": 45,
        "score": 2,
        "question1": "会社員の増田さんの本年分の所得等が下記＜資料＞のとおりである場合、増田さんが本年分の所得税の確定申告を行う際に、給与所得と損益通算できる損失はいくらになるか。なお、▲が付された所得金額は、その所得に損失が発生していることを意味するものとする。また、記載のない事項については一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"073ada94-025f-44e9-9768-2d4e71d8e035\" src='/img/4_19_1776850292656239.png'>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2309,
        "categoryName": "タックス",
        "rontenName": "給与所得と損益通算できる損失",
        "important": ""
    },
    {
        "id": 110,
        "shikenId": 4,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "広尾さん（６６歳）の本年分の収入等が下記＜資料＞のとおりである場合、広尾さんの本年分の所得税における総所得金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとし、総所得金額が最も少なくなるように計算すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"70e7227a-d82a-42a3-ba2d-188095eeece7\" src='/img/4_20_1776850293162171.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"f5482a14-5235-48b9-b745-e1f78533e072\" src='/img/4_20_1776850293805291.png'>",
        "question2": "",
        "choice1": "３３５万円",
        "choice2": "３４５万円",
        "choice3": "３５５万円",
        "choice4": "３９０万円",
        "choice5": 2309,
        "categoryName": "タックス",
        "rontenName": "総所得金額はどれか",
        "important": ""
    },
    {
        "id": 111,
        "shikenId": 4,
        "no": 21,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "住吉さんは、加入していた下記＜資料＞の養老保険が本年８月に満期を迎えたため、満期保険金を一括で受け取った。住吉さんの本年分の所得税において、総所得金額に算入すべき一時所得の金額として、正しいものはどれか。なお、住吉さんには、この満期保険金以外に一時所得の対象となるものはないものとする。<br><br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"8704f5f8-3bbd-41da-9df4-9366da618936\" src='/img/4_21_1776850294540233.png' style='width:350px !important'>",
        "question2": "",
        "choice1": "１０万円",
        "choice2": "２０万円",
        "choice3": "３５万円",
        "choice4": "７０万円",
        "choice5": 2309,
        "categoryName": "タックス",
        "rontenName": "総所得金額に算入すべき一時所得",
        "important": ""
    },
    {
        "id": 112,
        "shikenId": 4,
        "no": 22,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "question1": "ＦＰの高倉さんは、個人に対する所得税の仕組みについて義博さんから質問を受けた。高倉さんが下記＜イメージ図＞を使用して行った所得税に関する次の（ア）～（エ）の説明のうち、適切なものには○、不適切なものには×を選択しなさい。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"fd613923-b035-4e2e-8b18-3ff82eaac77c\" src='/img/4_22_1776850294887184.png'><br>（出所：財務省ＨＰ「所得税の基本的な仕組み」を基に作成）",
        "question2": "",
        "choice1": "「義博さんが収入保障保険の保険料を支払ったことにより受けられる生命保険料控除は、所得控除として、一定金額を所得金額から差し引くことができます。」",
        "choice2": "「由紀恵さんがふるさと納税をしたことにより受けられる寄附金控除は、税額控除として、一定金額を所得税額から差し引くことができます。」",
        "choice3": "「義博さんが空き巣に入られ盗難被害を受けたことによって受けられる雑損控除は、税額控除として、一定金額を所得税額から差し引くことができます。」",
        "choice4": "「由紀恵さんがケガで入院し入院費を支払ったことにより受けられる医療費控除は、所得控除として、一定金額を所得金額から差し引くことができます。」",
        "choice5": 2305,
        "categoryName": "タックス",
        "rontenName": "所得税の仕組み",
        "important": ""
    },
    {
        "id": 113,
        "shikenId": 4,
        "no": 23,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "下記＜資料＞の土地に係る路線価方式による普通借地権の相続税評価額の計算式として、正しいものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"cb2dbe36-bdf9-4883-91c4-98fcdf08cb77\" src='/img/4_23_1776850295368680.png'>",
        "question2": "",
        "choice1": "２００千円×１.００×３００㎡",
        "choice2": "２００千円×１.００×３００㎡×７０％",
        "choice3": "２００千円×１.００×３００㎡×（１－７０％）",
        "choice4": "２００千円×１.００×３００㎡×（１－７０％×３０％×１００％）",
        "choice5": 2301,
        "categoryName": "相続",
        "rontenName": "路線価方式による相続税評価額",
        "important": ""
    },
    {
        "id": 114,
        "shikenId": 4,
        "no": 24,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,2,1,4",
        "score": "1,1,1,1",
        "question1": "馬場さんは、ＦＰで税理士でもある藤原さんに、相続税において相続財産から控除できる債務等に関する質問をした。下記の空欄（ア）～（エ）に入る適切な語句を語群の中から選びなさい。なお、同じ番号を何度選んでもよいこととする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"3d6f7c69-2439-4e9e-834e-859bb4ff55e3\" src='/img/4_24_1776850295918529.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"3d58705a-6acc-45f6-90b3-237af1aff316\" src='/img/4_24_1776850296820696.png'>",
        "question2": "",
        "choice1": "1|2|3|4|5",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2301,
        "categoryName": "相続",
        "rontenName": "債務控除",
        "important": ""
    },
    {
        "id": 115,
        "shikenId": 4,
        "no": 25,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "工藤さん（５９歳）は、本年１２月に夫から居住用不動産（財産評価額２,７５０万円）の贈与を受けた。工藤さんが贈与税の配偶者控除の適用を受けた場合の本年分の贈与税額として、正しいものはどれか。なお、本年においては、このほかに工藤さんが受けた贈与はないものとする。また、納付すべき贈与税額が最も少なくなるように計算すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"d4951e9e-8641-442a-93f3-e7f325e657c6\" src='/img/4_25_1776850297158918.png'>",
        "question2": "",
        "choice1": "１４万円",
        "choice2": "１０２万円",
        "choice3": "１３１万円",
        "choice4": "１７５万円",
        "choice5": 2301,
        "categoryName": "相続",
        "rontenName": "贈与税額はどれか",
        "important": ""
    },
    {
        "id": 116,
        "shikenId": 4,
        "no": 26,
        "answerType": 8,
        "groupId": 1,
        "answer": "5,9,2",
        "score": "1,1,1",
        "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句または数値を語群の中から選びなさい。なお、同じ番号を何度選んでもよいものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"808f93ea-72c2-45fd-b56d-dc245e11c3bb\" src='/img/4_26_1776850297957551.png'><br>［各相続人の法定相続分および遺留分］<br>・被相続人の弟の法定相続分は（ ア ）である。<br>・被相続人の甥の法定相続分は（ イ ）である。<br>・被相続人の配偶者の遺留分は（ ウ ）である。<br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"c85c7bc5-f309-473b-8861-08e1e2c6bc47\" src='/img/4_26_1776850298334093.png'>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2409,
        "categoryName": "相続",
        "rontenName": "法定相続分・遺留分",
        "important": ""
    },
    {
        "id": 117,
        "shikenId": 4,
        "no": 27,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "相続税における小規模宅地等の特例に関する下表の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"3c63d755-b07b-4cd1-a4e6-1b50ce6eab7f\" src='/img/4_27_1776850298637620.png'>",
        "question2": "",
        "choice1": "（ア）３００ （イ）２００ （ウ）７０",
        "choice2": "（ア）３００ （イ）２４０ （ウ）８０",
        "choice3": "（ア）３３０ （イ）２００ （ウ）８０",
        "choice4": "（ア）３３０ （イ）２４０ （ウ）７０",
        "choice5": 2505,
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 118,
        "shikenId": 4,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 464,
        "score": 2,
        "question1": "下記は、島田家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"941499fd-dedf-4319-8c39-a3d4ba12ccf4\" src='/img/4_28_1776850299120823.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。また、問題作成の都合上、一部を空欄としている。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2505,
        "categoryName": "ライフ",
        "rontenName": "CF表",
        "important": ""
    },
    {
        "id": 119,
        "shikenId": 4,
        "no": 29,
        "answerType": 9,
        "groupId": 0,
        "answer": 729,
        "score": 2,
        "question1": "下記は、杉田家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"7b837823-c198-4fbe-a5b0-13e420288a30\" src='/img/4_29_1776850299966916.png'>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "ライフ",
        "rontenName": "CF表",
        "important": ""
    },
    {
        "id": 120,
        "shikenId": 4,
        "no": 30,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "康人さんは、教育費の負担が心配になり、奨学金について調べることにした。日本学生支援機構の奨学金に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "給付型奨学金の収入基準の判定は、申込人と父母の３人家族の場合、父母のどちらか収入の高い方１名を生計維持者として、判定を行う。",
        "choice2": "給付型奨学金の「予約採用」は、学力基準である「高等学校等における全履修科目の評定平均値が一定以上」という要件を満たしていない場合、申し込むことができない。",
        "choice3": "貸与型奨学金には、利息が付く「第一種」と利息が付かない「第二種」がある。",
        "choice4": "貸与型奨学金は、「第一種」と「第二種」を併用することができる。",
        "choice5": 2401,
        "categoryName": "ライフ",
        "rontenName": "日本学生支援機構の奨学金",
        "important": ""
    },
    {
        "id": 121,
        "shikenId": 4,
        "no": 31,
        "answerType": 9,
        "groupId": 0,
        "answer": 3656000,
        "score": 2,
        "question1": "倉田さんは、住宅のリフォーム費用として９年後に４００万円を準備したいと考えている。９年間、年利１．０％で複利運用する場合、現在いくらの資金があればよいか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"638dc272-cf20-48de-af95-b8ed3513a2da\" src='/img/4_31_1776850300887153.png'>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2209,
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 122,
        "shikenId": 4,
        "no": 32,
        "answerType": 9,
        "groupId": 0,
        "answer": 52855200,
        "score": 2,
        "question1": "山本さんは、老後の生活資金として、毎年年末に２４０万円を受け取りたいと考えている。受取期間を２５年とし、年利１．０％で複利運用した場合、受取り開始年の初めにいくらの資金があればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"638dc272-cf20-48de-af95-b8ed3513a2da\" src='/img/4_32_1776850301671723.png'>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2209,
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 123,
        "shikenId": 4,
        "no": 33,
        "answerType": 9,
        "groupId": 0,
        "answer": 496000,
        "score": 2,
        "question1": "落合さんは、定年後の世界一周旅行の資金として、１５年後に８００万円を用意しようと考えている。年利１．０％で複利運用しながら毎年年末に一定額を積み立てる場合、毎年いくらずつ積み立てればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"638dc272-cf20-48de-af95-b8ed3513a2da\" src='/img/4_33_1776850302330056.png'>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2209,
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 124,
        "shikenId": 4,
        "no": 34,
        "answerType": 9,
        "groupId": 0,
        "answer": 12550,
        "score": 2,
        "question1": "池谷家（雅之さんと博子さん）の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく池谷家のバランスシートの空欄（ア）にあてはまる数値を計算しなさい。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"1cbd0b7d-6b1a-4929-ae0b-f01d9ee4a80c\" src='/img/4_34_1776850303076407.png'><br><img data-image-id=\"I2\"  data-asset-scope=\"content_extraction\" data-asset-id=\"e8fef3b2-645f-4ea5-9455-9196290a942c\" src='/img/4_34_1776850303889458.png'>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2401,
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 125,
        "shikenId": 4,
        "no": 35,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "湯川さんは、現在居住している自宅の住宅ローン（全期間固定金利、返済期間２５年、元利均等返済、ボーナス返済なし）の繰上げ返済を検討している。湯川さんが住宅ローンを１２０回返済後に、８０万円以内で期間短縮型の繰上げ返済をする場合、この繰上げ返済により短縮される返済期間として、正しいものはどれか。なお、計算に当たっては、下記＜資料＞を使用し、繰上げ返済額は８０万円を超えない範囲での最大額とすること。また、繰上げ返済に伴う手数料等は考慮しないものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"39eccbb9-b1ed-4efb-b2b0-1183714f3e3b\" src='/img/4_35_1776850304482631.png'>",
        "question2": "",
        "choice1": "７ヵ月",
        "choice2": "８ヵ月",
        "choice3": "１１ヵ月",
        "choice4": "１年０ヵ月",
        "choice5": 2505,
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの繰り上げ返済",
        "important": ""
    },
    {
        "id": 126,
        "shikenId": 4,
        "no": 36,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "義博さんの健康保険料に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択しなさい。なお、義博さんは全国健康保険協会管掌健康保険（以下「協会けんぽ」という）の被保険者である。また、健康保険料の計算に当たっては、下記＜資料＞に基づくこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"dab87147-edd5-4ff1-81b7-b2495f48d58c\" src='/img/4_36_1776850305298138.png'>",
        "question2": "",
        "choice1": "毎月の給与に係る健康保険料のうち、義博さんの負担分は１５,０００円である。",
        "choice2": "年２回支給される賞与に係る健康保険料については、義博さんの負担分はない。",
        "choice3": "義博さんが負担した健康保険料は、所得税の計算上、全額が社会保険料控除の対象となる。",
        "choice4": "",
        "choice5": 2305,
        "categoryName": "ライフ",
        "rontenName": "健康保険料",
        "important": ""
    },
    {
        "id": 127,
        "shikenId": 4,
        "no": 37,
        "answerType": 8,
        "groupId": 1,
        "answer": "4,1,8,10",
        "score": "1,1,1,1",
        "question1": "由紀恵さんは、義博さんが万一死亡した場合の公的年金の遺族給付について、ＦＰの高倉さんに相談をした。義博さんが、本年６月に３５歳で在職中に死亡した場合に、由紀恵さんが受け取ることができる遺族給付を示した下記＜イメージ図＞の空欄（ア）〜（エ）に入る適切な語句を語群の中から選びなさい。なお、義博さんは、２０歳から大学卒業まで国民年金に加入し、大学卒業後の２２歳から死亡時まで継続して厚生年金保険に加入しているものとする。また、家族に障害者に該当する者はなく、記載以外の遺族給付の受給要件はすべて満たしているものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"9f12d5f9-2520-4b24-9f1c-af3aa17e528a\" src='/img/4_37_1776850305988204.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"f334ca8a-f821-4663-bed2-7306383cebdc\" src='/img/4_37_1776850306490429.png'>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2305,
        "categoryName": "ライフ",
        "rontenName": "公的年金の遺族給付",
        "important": ""
    },
    {
        "id": 128,
        "shikenId": 4,
        "no": 38,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,4,7",
        "score": "1,1,1",
        "question1": "義博さんの母親の弘子さんは今年６５歳になる。義博さんは、弘子さんの老齢基礎年金の繰下げ受給についてＦＰの高倉さんに質問をした。老齢基礎年金の繰下げ受給に関する次の記述の空欄（ア）〜（ウ）に入る適切な語句を語群の中から選びなさい。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"4c31edde-240e-4906-838c-f23c22140f9e\" src='/img/4_38_1776850306988950.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"c2089adf-c58a-4bf2-80b6-ea12edf5d20b\" src='/img/4_38_1776850307694082.png'>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": 2305,
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の繰下げ受給",
        "important": ""
    },
    {
        "id": 129,
        "shikenId": 4,
        "no": 39,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "雅之さんは、現在の勤務先で、６０歳の定年を迎えた後も継続雇用制度を利用し、厚生年金保険に加入しつつ７０歳まで働き続ける場合の在職老齢年金について、ＦＰの最上さんに質問をした。下記＜資料＞に基づく条件で支給調整された老齢厚生年金の受給額（年額）として、正しいものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"9369a02f-2b75-40b3-af50-1cf0ebc4f7d2\" src='/img/4_39_1776850308146964.png'>",
        "question2": "",
        "choice1": "５４０,０００円",
        "choice2": "７８０,０００円",
        "choice3": "９３０,０００円",
        "choice4": "１,０５０,０００円",
        "choice5": 2401,
        "categoryName": "ライフ",
        "rontenName": "在職老齢年金",
        "important": ""
    },
    {
        "id": 130,
        "shikenId": 4,
        "no": 40,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "博子さんは、現在、雅之さんが加入する全国健康保険協会管掌健康保険（協会けんぽ）の被扶養者となっている。今後、博子さんがパートタイマーとして地元の中小企業ＰＥ株式会社で働き始めた場合でも、引き続き雅之さんが加入する健康保険の被扶養者となるための条件について、ＦＰの最上さんに質問をした。健康保険の被保険者および被扶養者に関する次の説明の空欄（ア）～（ウ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。なお、ＰＥ株式会社の従業員数は５０人以下であり、任意特定適用事業所ではないものとする。また、問題作成の都合上、一部を「＊＊＊」にしてある。<br><br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"6e08f38b-6f6b-4ef8-b86a-f3d7222d343d\" src='/img/4_40_1776850309069601.png'>",
        "question2": "",
        "choice1": "（ア）３分の２ （イ）１０３ （ウ）２分の１",
        "choice2": "（ア）３分の２ （イ）１３０ （ウ）３割",
        "choice3": "（ア）４分の３ （イ）１０３ （ウ）３割",
        "choice4": "（ア）４分の３ （イ）１３０ （ウ）２分の１",
        "choice5": 2401,
        "categoryName": "ライフ",
        "rontenName": "健康保険の被扶養者",
        "important": ""
    }
]